import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import '../CSS/View.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { withRouter } from 'react-router-dom';
import {
    getTaxes, getCardType, recordPayment, cardConnectPaymemt, spaceSpecificRates, getSiteRigDiscountExtra, getPayments, checkIn,
    checkOut, confirmReservation, getIntegrations, addVariableCharge, addExtras, getExtrasAndVariableCharges, getEmailTemplates,
    getEmails, sendMail, deleteAddedExtra, cardConnectGetListOfTerminals, cardConnectConnectToTerminal, cardConnectTerminalPayment,
    customerDetailChanges, internalNotesChanges, changeSpace, updateReservationTotal, getRemoteReservationsStatus,
    editReservationDates, addCancellationCharge, getSpacesCurrent, updateSpaceCurrent, getSiteTaxes,
    addSystemFeeRecord, deleteAddedVariableCharge, getReplayID, updateReplayID,
    deleteSystemFeeRecord, cancel, getVariableRatesStatus, getAllseasons, getPaymentMethod
} from '../utils/OpenCampground_Database_Calls'
import { camperDetailsForReservation } from '../utils/OpenCampground_Database_Calls'
import { makePayment, makeVaultedPayment, getJWTToken, getListOfTerminals, createTerminalPayment, getTerminalTransaction } from '../utils/MxMerchant_Services'
import { format, differenceInCalendarDays, addDays, isBefore, isAfter, min, max } from 'date-fns';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { withStyles } from '@material-ui/core/styles';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import GroupIcon from '@mui/icons-material/Group';
import PetsIcon from '@mui/icons-material/Pets';
import DateRangeIcon from '@mui/icons-material/DateRange';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import TodayIcon from '@mui/icons-material/Today';
import dayjs from "dayjs";
import { CircularProgress } from '@material-ui/core';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PrintReservation from './PrintReservation';
import boat from '../assets/boat.png';
import freshWater from '../assets/freshWater.png'
import pumpOut from '../assets/water.png'
import power from '../assets/power.png'
import rv from '../assets/RV.png'
import measuring from '../assets/measuring.png'
import StripePayment from './StripePayment';

const useStyles = theme => ({
    circularProgress: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        color: '#2dcd7a'
    },
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

const GreenCheckbox = styled(Checkbox)({
    color: '#000000',
    '&.Mui-checked': {
        color: '#2dcd7a',
    },
});

const reasonMap = {
    change_of_plans: "Change of plans, no longer need the reservation",
    weather: "Severe weather or unsafe conditions",
    illness: "Illness or medical emergency",
    family_emergency: "Family emergency requiring travel changes",
    work_conflict: "Work schedule conflicts",
    financial_constraints: "Unexpected financial constraints",
    vehicle_issues: "RV, boat, or vehicle issues",
    incorrect_booking: "Incorrect date, site type, or location booked",
    group_canceled: "Group or travel companions canceled",
    event_canceled: "Event cancellation or rescheduling",
    travel_restrictions: "Illness, exposure, or travel restrictions",
    safety_concerns: "Safety concerns about the site or area",
    better_accommodation: "Found a better-suited accommodation",
    not_meet_expectations: "Site does not meet expectations or needs",
    road_closures: "Road closures or government travel restrictions",
    overbooking: "Reservation canceled due to overbooking",
    maintenance: "Site closed for maintenance or repairs",
    extreme_weather: "Extreme weather affecting site access",
    health_safety: "Health or safety issues at the property",
    policy_conflict: "Policy conflict",
    payment_issues: "Payment issues or failed transaction",
    prior_misconduct: "Prior misconduct or policy violations",
    staffing_shortages: "Staffing shortages affecting operations",
    facility_issues: "Power, water, or facility issues",
    legal_changes: "Legal or regulatory changes",
    no_show: "No Show"
};

const toUTCDateOnly = function(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };
const offsetMinutes = new Date().getTimezoneOffset();

const methods =["Bank Transfer", "Wire Transfer", "Venmo", "PayPal", "Zelle", "Apple Pay", "Google Pay", "Gift Card", "Square", "Others"]

class View extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerDetails: {},
            days: '',
            weeks: '',
            months: '',
            season: '',
            seasonTotal: '',
            subTotal: '',
            subTotalWithoutDiscount: '',
            subTotalWithoutDiscount1: '',
            monthsTotal: '',
            weeksTotal: '',
            daysTotal: '',
            taxes: [],
            totalAmount: '',
            tax: [],
            taxPercent: [],
            taxName: [],
            convenienceCharge: null,
            convenienceFees: '',
            baseTotal: 0.0,
            daily: '',
            weekly: '',
            monthly: '',
            seasonal: '',
            selectedPaymentValue: '',
            ccPOSAmount: '',
            extras: [],
            selectedExtras: [],
            selectedExtraAmount: [],
            selectedExtraCount: [],
            selectedExtrasTypeId: [],
            extraSubTotal: 0,
            counts: [],
            extraId: [],
            start: [],
            end: [],
            type2Add: false,
            userDetailsFormValid: false,
            payments: [],
            totalPaidAmount: 0.0,
            partialTotal: 0.0,
            extrasTotal: 0.0,
            variablesTotalTaxable: 0.0,
            partialBase: '',
            cashDate: format(new Date(), 'MM/dd/yyyy'),
            cashAmount: '',
            cardNumber: '',
            cardOwner: '',
            expiryMonth: '',
            expiryYear: '',
            cvv: '',
            paymentIntegration: [],
            variableCharges: [],
            reservedExtra: [],
            checkAmount: '',
            checkNumber: '',
            memo: '',
            checkDate: format(new Date(), 'MM/dd/yyyy'),
            totalTaxAmount: 0,
            offlineAmount: null,
            offlineMethod: null,
            offlineMemo: '',
            offlineLast4: null,
            offlinePaymentDate: null,
            //email
            remoteResConfirmedMailMessage: '',
            remoteResConfirmedSubject: '',
            confirmedAttachments: [],
            remoteResRejectedMailMessage: '',
            remoteResRejectedSubject: '',
            rejectedAttachments: [],
            reservationCancelMailMessage: '',
            reservationCancelSubject: '',
            cancelAttachments: [],
            reservationFeedbackMailMessage: '',
            reservationFeedbackSubject: '',
            feedbackAttachments: [],
            reservationUpdateMailMessage: '',
            reservationUpdateMailSubject: '',
            updateAttachments: [],
            sender: '',
            reply: '',
            cc: '',
            bcc: '',
            open: false,
            popupText: '',
            open1: false,
            popupText1: '',
            disabledTextFields: true,
            disabledInternalNotes: true,
            fname: null,
            lname: null,
            emailId: null,
            phoneNumber: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            internalNote: null,
            amtToPay: '',
            ccfees: '',
            totalPayableAmt: '',
            discountTotal: null,
            discountPercent: null,
            oneTimeDiscount: null,

            //spaces
            changeSpace: false,
            chnageSpaceTitle: 'Select Dates for reservation number ' + this.props.viewItem.id,
            spaceData: [],
            showNewSpaces: false,
            editedStartDate: this.props.viewItem.startdate,
            editedEndDate: this.props.viewItem.enddate,
            discountByPercent: false,
            oldVariableCharge: null,
            waitForCalculations: true,
            spaceId: '',
            sitetype_id: this.props.viewItem.sitetype_id,
            discounts: [],
            discount: null,
            discount_id: this.props.viewItem.discount_id,

            extraPopup: false,
            extraPopupTitle: '',
            open2: false,
            newVariableChargeName: '',
            newVariableChargeAmount: null,
            taxable: true,
            Popup3DialogTitle: "",
            popup3Text: "",
            open3: false,
            last4: null,
            paymentToken: null,
            payWithSavedCard: false,
            saveCard: false,
            cancellationReason: '',
            cancelPopup: false,
            cancellationCharge: '',
            lastMeterReading: '',
            pritOpen: false,
            daySpecificRatesStatus: '',
            dayChunks: [],
            blended: false,
            monthChunks: [],
            weekChunks: []
        };
    }

    async componentDidMount() {
        console.log("viewItem: ", this.props.viewItem)
        let paymentIntegration = await getIntegrations(this.props.user, this.props.serverName)
        let mailMessages = await getEmailTemplates(this.props.user, this.props.serverName)
        let email = await getEmails(this.props.user, this.props.serverName)
        let remoteActive = await getRemoteReservationsStatus(this.props.user, this.props.serverName);
        //get variable charges and extras
        let getSpacesCurrentResponse = await getSpacesCurrent(this.props.user, this.props.serverName, this.props.viewItem.sitename)
        console.log("getSpacesCurrentResponse: ", getSpacesCurrentResponse[0].current)
        let variableChargesAndExtras = await getExtrasAndVariableCharges(this.props.user, this.props.serverName, this.props.viewItem.id)
        const daySpecificRatesStatus = this.props.viewItem.is_variable;
        let extrasTotal = 0;
        let variablesTotalTaxable = 0;
        variableChargesAndExtras[1].forEach(extra => {
            extrasTotal += extra.charge;
        });
        variableChargesAndExtras[1].forEach(extra => {
            this.setState(prevState => ({
                selectedExtras: [...prevState.selectedExtras, extra.name],
                selectedExtraCount: [...prevState.selectedExtraCount, extra.number],
                selectedExtraAmount: [...prevState.selectedExtraAmount, extra.charge],
                extraSubTotal: extrasTotal,
                extraId: [...prevState.extraId, extra.id],
                selectedExtrasTypeId: [...prevState.selectedExtrasTypeId, extra.extra_id]
            }));
        });
        variableChargesAndExtras[0]?.forEach(variable => {
            if (variable?.taxable)
                variablesTotalTaxable += variable.amount;
        });
        //past transsactions
        let paymentsResponse = await getPayments(this.props.user, this.props.serverName, this.props.viewItem.id)

        //calculate balance
        let totalPaidAmount = paymentsResponse.reduce((acc, payment) => acc + payment.amount, 0);
        let extras = await getSiteRigDiscountExtra(this.props.user, this.props.serverName)
        let customerDetails = await camperDetailsForReservation(this.props.user, this.props.serverName, this.props.viewItem.id)
        //calculate total
        let term = this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate);
        console.log("term: ", term)
        let subTotal = 0.0
        let subTotalWithoutDiscount1 = 0.0;
        let seasonTotal = 0;
        let subTotalWithoutDiscount = 0.0;
        let monthsTotal = 0
        let weeksTotal = 0
        let daysTotal = 0
        let daily = ''
        let weekly = ''
        let monthly = ''
        let seasonal = ''
        let spaceId = ''
        let discountTotal = null
        let selectedDiscount
        //get rates for selected space before this
        let spaceSpecificRatesResponse = await spaceSpecificRates(this.props.user, this.props.serverName, this.props.viewItem.startdate, this.props.viewItem.enddate, this.props.viewItem.sitename)
        let seasons = await getAllseasons(this.props.user, this.props.serverName, this.props.viewItem.startdate, this.props.viewItem.enddate, this.props.viewItem.sitename)
        let monthChunks = [];
        let weekChunks = [];
        let dayChunks = [];
        if(seasons.length>1){
            this.setState({
                blended: true
            })
        }
        daily = spaceSpecificRatesResponse?.daily_rate
        weekly = spaceSpecificRatesResponse?.weekly_rate
        monthly = spaceSpecificRatesResponse?.monthly_rate
        seasonal = spaceSpecificRatesResponse?.seasonal_rate
        spaceId = spaceSpecificRatesResponse?.id
        const daySpecificRates = {
            0: spaceSpecificRatesResponse?.sunday,
            1: spaceSpecificRatesResponse?.monday,
            2: spaceSpecificRatesResponse?.tuesday,
            3: spaceSpecificRatesResponse?.wednesday,
            4: spaceSpecificRatesResponse?.thursday,
            5: spaceSpecificRatesResponse?.friday,
            6: spaceSpecificRatesResponse?.saturday
        };
        if (this.props.viewItem.seasonal === 1) {
            seasonTotal = seasonal
            subTotal += seasonTotal
            subTotalWithoutDiscount += seasonTotal
        } else {
            // if (term[2] > 0) {
            //     if (monthly > 0) {
            //         monthsTotal = (term[2] * monthly);
            //         subTotal += monthsTotal;
            //         subTotalWithoutDiscount += monthsTotal
            //     } else {
            //         let totalDaysFromMonths = 0;
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(this.props.viewItem.startdate);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             const monthDays = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
            //             totalDaysFromMonths += monthDays;
            //         }
            //         // term[1] = term[1] + (totalDaysFromMonths / 7);
            //         // term[2] = 0;
            //         const weeksFromMonths = Math.floor(totalDaysFromMonths / 7);
            //         const leftoverDays = totalDaysFromMonths % 7;
            //         term[1] += weeksFromMonths;
            //         term[0] += leftoverDays;
            //     }
            // }
            // if (term[1] > 0) {
            //     if (weekly > 0) {
            //         weeksTotal = ((term[1]) * weekly);
            //         subTotal += weeksTotal;
            //         subTotalWithoutDiscount += weeksTotal
            //     } else {
            //         term[0] = term[0] + (term[1] * 7);
            //         term[1] = 0
            //     }
            // }
            // if (term[0] > 0) {
            //     if(this.props.viewItem.is_variable){
            //         let checkInDate = new Date(this.props.viewItem.startdate);
            //         let daysToAdvance = 0;
            //         let baseDate = new Date(this.props.viewItem.startdate);
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(baseDate);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             let year = monthDate.getFullYear();
            //             let month = monthDate.getMonth();
            //             let daysInMonth = new Date(year, month + 1, 0).getDate();
            //             daysToAdvance += daysInMonth;
            //         }
            //         checkInDate.setDate(checkInDate.getDate() + daysToAdvance);
            //         for (let i = 0; i < term[0]; i++) {
            //             const dayOfWeek = checkInDate.getUTCDay();
            //             console.log('the day of thee week', dayOfWeek);
            //             const dayspecificrate = daySpecificRates[dayOfWeek] ?? this.props.daily ?? 0;
            //             console.log(`the day of thee week ${dayOfWeek} and its price ${dayspecificrate} ${this.props.sunday} ${this.props.Saturday}`);
            //             daysTotal += dayspecificrate;
            //             subTotal += dayspecificrate;
            //             subTotalWithoutDiscount += dayspecificrate;
            //             checkInDate.setDate(checkInDate.getDate() + 1);
            //         }}
            //     else{
            //     daysTotal = (Math.round(term[0]) * daily);
            //     subTotal += daysTotal;
            //     subTotalWithoutDiscount += daysTotal;
            //     }
            // }
            // let monthDate = new Date(this.props.viewItem.startdate);
            let monthDate = offsetMinutes > 0? toUTCDateOnly(this.props.viewItem.startdate): new Date(this.props.viewItem.startdate);
            if(term[2]){
                let monthEndDate = new Date(monthDate);
                monthEndDate.setMonth(monthEndDate.getMonth() + term[2]);
                monthChunks = this.calculateReservationCost(monthDate, monthEndDate, seasons, term[2])
                monthsTotal = monthChunks.monthsTotal;
                subTotal += monthChunks.monthsTotal;
                subTotalWithoutDiscount += monthChunks.monthsTotal;
                monthDate.setMonth(monthDate.getMonth() + term[2]);
                console.log(JSON.stringify(monthChunks));
            }
            if(term[1]){
                let weekEndDate = new Date(monthDate);
                weekEndDate.setDate(monthDate.getDate() + term[1] * 7);
                weekChunks = this.calculateWeeklyReservationCost(monthDate, weekEndDate, seasons)
                weeksTotal = weekChunks.weeksTotal
                subTotal += weekChunks.weeksTotal;
                subTotalWithoutDiscount += weekChunks.weeksTotal
                monthDate.setDate(monthDate.getDate() + term[1] * 7);
                console.log(JSON.stringify(weekChunks));
            }
            if(term[0] || this.state.dayChunks.length){
                let endDate = new Date(this.props.viewItem.enddate);
                dayChunks = this.calculateDailyReservationCost(monthDate, endDate, seasons, daySpecificRatesStatus)
                daysTotal = dayChunks.daysTotal;
                subTotal += dayChunks.daysTotal;
                subTotalWithoutDiscount += dayChunks.daysTotal
                console.log(JSON.stringify(dayChunks));
            }
        }

        subTotalWithoutDiscount1 = subTotal;

        if (this.props.viewItem.discount_id > 0) {
            console.log(extras[2])
            selectedDiscount = extras[2].find(
                (discount) => discount.id === this.props.viewItem.discount_id
            );
            if (selectedDiscount != null) {
                if (selectedDiscount.amount > 0) {
                    discountTotal = selectedDiscount.amount
                } else if (selectedDiscount.amount_daily > 0 || selectedDiscount.amount_monthly > 0 || selectedDiscount.amount_weekly > 0) {
                    if (term[2] > 0 && selectedDiscount.amount_monthly > 0) {
                        discountTotal += (term[2] * selectedDiscount.amount_monthly)
                    }
                    if (term[1] > 0 && selectedDiscount.amount_weekly > 0) {
                        discountTotal += (term[1] * selectedDiscount.amount_weekly)
                    }
                    if (term[0] > 0 && selectedDiscount.amount_daily > 0) {
                        discountTotal += (term[0] * selectedDiscount.amount_daily)
                    }
                } else {
                    if (monthsTotal > 0 && selectedDiscount.disc_appl_month) {
                        discountTotal += (monthsTotal * selectedDiscount.discount_percent) / 100
                    }
                    if (weeksTotal > 0 && selectedDiscount.disc_appl_week) {
                        discountTotal += (weeksTotal * selectedDiscount.discount_percent) / 100
                    }
                    if (daysTotal > 0 && selectedDiscount.disc_appl_daily) {
                        discountTotal += (daysTotal * selectedDiscount.discount_percent) / 100
                    }
                    this.setState({
                        discountByPercent: true
                    })
                }
                subTotal -= discountTotal
                subTotalWithoutDiscount -= discountTotal
            }
        }
        subTotal -= this.props.viewItem.onetime_discount
        this.setState({
            discountTotal: discountTotal,
            discountPercent: this.props.viewItem.discount_id > 0 && selectedDiscount != null ? selectedDiscount.discount_percent : null,
            payments: paymentsResponse,
            customerDetails: customerDetails,
            extras: extras[3],
            discounts: extras[2],
            discount: selectedDiscount,
            daily: daily,
            weekly: weekly,
            monthly: monthly,
            seasonal: seasonal,
            spaceId: spaceId,
            season: this.props.viewItem.seasonal === 1 ? '1' : '0',
            days: Math.round(term[0]),
            weeks: Math.round(term[1]),
            months: term[2],
            subTotal: subTotal + extrasTotal,
            subTotalWithoutDiscount1: subTotalWithoutDiscount1 + extrasTotal,
            subTotalWithoutDiscount: subTotalWithoutDiscount + extrasTotal,
            oneTimeDiscount: this.props.viewItem.onetime_discount,
            seasonTotal: seasonTotal,
            monthsTotal: monthsTotal,
            weeksTotal: weeksTotal,
            daysTotal: daysTotal,
            totalPaidAmount: totalPaidAmount,
            variableCharges: variableChargesAndExtras[0],
            reservedExtra: variableChargesAndExtras[1],
            fname: customerDetails?.first_name,
            lname: customerDetails?.last_name,
            emailId: customerDetails?.email,
            phoneNumber: customerDetails?.phone,
            address: customerDetails?.address,
            city: customerDetails?.city,
            state: customerDetails?.state,
            zip: customerDetails?.mail_code,
            last4: customerDetails?.last4,
            paymentToken: customerDetails?.token,
            internalNote: this.props.viewItem.special_request,
            remoteResConfirmedMailMessage: mailMessages[4].body,
            remoteResConfirmedSubject: email.remote_res_confirm_subject,
            confirmedAttachments: mailMessages[4].attachments,
            remoteResRejectedMailMessage: mailMessages[5].body,
            remoteResRejectedSubject: email.remote_res_reject_subject,
            rejectedAttachments: mailMessages[5].attachments,
            reservationCancelMailMessage: mailMessages[7].body,
            reservationCancelSubject: email.reservation_cancel_subject,
            cancelAttachments: mailMessages[7].attachments,
            reservationFeedbackMailMessage: mailMessages[2].body,
            reservationFeedbackSubject: email.feedback_subject,
            feedbackAttachments: mailMessages[2].attachments,
            reservationUpdateMailMessage: mailMessages[1].body,
            reservationUpdateMailSubject: email.update_subject,
            updateAttachments: mailMessages[1].attachments,
            sender: email.sender,
            reply: email.reply,
            cc: email.cc,
            bcc: email.bcc,
            paymentIntegration: paymentIntegration,
            selectedPaymentValue: paymentIntegration.name === "None" ? "cash" : "fullPayment",
            convenienceFees: paymentIntegration.credit_charges * 100,
            extrasTotal: extrasTotal,
            variablesTotalTaxable: variablesTotalTaxable,
            useVariable: remoteActive[0].use_variable_charge === 1 ? true : false,
            lastMeterReading: getSpacesCurrentResponse[0].current,
            daySpecificRatesStatus: daySpecificRatesStatus,
            monthChunks: monthChunks.chunks || [],
            weekChunks: weekChunks.chunks || [],
            dayChunks: dayChunks.chunks || []
        })
        this.calculateTaxAndTotal(subTotal + extrasTotal, term, extrasTotal);
    }
    getAverageMonthDays(from, to, monthsCount) {
        const fromDate = new Date(from);
        
        // If only one month, return the number of days in the 'from' month
        if (monthsCount <= 1) {
          const year = fromDate.getFullYear();
          const month = fromDate.getMonth();
          return new Date(year, month + 1, 0).getDate();
        }
      
        // Otherwise, calculate the average days per month in the range
        let totalMonthDays = 0;
        let count = 0;
        let current = new Date(fromDate);
      
        while (current < to) {
          const year = current.getFullYear();
          const month = current.getMonth();
          const daysInMonth = new Date(year, month + 1, 0).getDate();
      
          totalMonthDays += daysInMonth;
          count++;
      
          // Move to next month
          current = new Date(year, month + 1, 1);
        }
      
        return count > 0 ? totalMonthDays / count : 30;
    }

    calculateReservationCost(reservationStart, reservationEnd, seasons, monthsCount) {
        let monthsTotal = 0;
        seasons =  seasons.filter(s => s.applies_to_monthly);
        const boundaries = new Set();
      
        // Ensure all dates are Date objects
        reservationStart = new Date(reservationStart);
        reservationEnd = new Date(reservationEnd);
      
        // Find boundaries based on season overlaps
        seasons.forEach(season => {
          const start = new Date(season.season_start);
          const end = addDays(new Date(season.season_end), 1); // inclusive
      
          if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;
      
          boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
          boundaries.add(min([reservationEnd, end]).toISOString().split('T')[0]);
        });
      
        // Add reservation start and end to ensure full coverage
        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);
      
        const sortedBoundaries = Array.from(boundaries)
          .map(d => offsetMinutes > 0? toUTCDateOnly(d):new Date(d))
          .sort((a, b) => a - b);
      
        const chunks = [];
      
        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
          const from = sortedBoundaries[i];
          const to = sortedBoundaries[i + 1];

          if (differenceInCalendarDays(to, from) <= 0) continue;
      
          const applicableSeasons = seasons.filter(season => {
            const seasonStart = new Date(season.season_start);
            const seasonEndInclusive = addDays(new Date(season.season_end), 1);
            return from < seasonEndInclusive && to > seasonStart;
          });
      
          const season = applicableSeasons.sort(
            (a, b) =>
              (new Date(a.season_end) - new Date(a.season_start)) -
              (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1); // fallback
      
          const days = differenceInCalendarDays(to, from);
        //   const months = days / 30;
          const avgMonthDays = this.getAverageMonthDays(from, to, monthsCount);
          const months = days / avgMonthDays;
          const cost = parseFloat((months * season.monthly_rate).toFixed(2));
          monthsTotal += cost;

          if(cost == 0){
            this.setState({
                dayChunks: [...this.state.dayChunks, {from:from.toString(),to:to.toString(),days:days,seasonName:season.season_name,seasonId:season.season_id}]
            })
          }
          else{
            chunks.push({
                from: format(new Date(sortedBoundaries[i]), 'MMM d, yy'),
                to: format(new Date(sortedBoundaries[i + 1]), 'MMM d, yy'),
                days,
                months: months.toFixed(3),
                season: season.season_name,
                cost,
            });
          }
        }
      
        return {chunks, monthsTotal};
      }

    calculateWeeklyReservationCost(reservationStart, reservationEnd, seasons) {
        console.log(reservationStart, reservationEnd);
        let weeksTotal = 0;
        seasons =  seasons.filter(s => s.applies_to_weekly);
        const boundaries = new Set();
      
        seasons.forEach(season => {
          const start = new Date(season.season_start);
          const end = new Date(season.season_end);
          if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;
      
          boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
          boundaries.add(min([reservationEnd, new Date(end.getTime() + 86400000)]).toISOString().split('T')[0]); // inclusive
        });
      
        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);
      
        const sortedBoundaries = Array.from(boundaries).sort();
        const chunks = [];
      
        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
        //   const from = new Date(sortedBoundaries[i]);
        //   const to = new Date(sortedBoundaries[i + 1]);
        const from = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i]):new Date(sortedBoundaries[i]);
        const to = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i+1]):new Date(sortedBoundaries[i+1]);
          if (differenceInCalendarDays(to, from) <= 0) continue;

        //   const applicableSeasons = seasons.filter(season => {
        //     const seasonStart = new Date(season.season_start);
        //     const seasonEnd = new Date(season.season_end);
        //     return from <= seasonEnd && to >= seasonStart; // Overlap allowed
        //   });
        const applicableSeasons = seasons.filter(season => {
            const seasonStart = new Date(season.season_start);
            const seasonEndInclusive = addDays(new Date(season.season_end), 1);
            return from < seasonEndInclusive && to > seasonStart;
        });
          
          const season = applicableSeasons.sort((a, b) =>
            (new Date(a.season_end) - new Date(a.season_start)) -
            (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1);
      
          const days = differenceInCalendarDays(to, from);
          const weeks = days / 7;
          const cost = parseFloat((weeks * season.weekly_rate).toFixed(2));
          weeksTotal += cost;

          if(cost == 0){
            this.setState({
                dayChunks: [...this.state.dayChunks, {from:from,to:to,days:days,seasonName:season.season_name,seasonId:season.season_id}]
            })
          }
          else{
            chunks.push({
                from: format(offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i]):new Date(sortedBoundaries[i]), 'MMM d, yy'),
                to: format(offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i+1]):new Date(sortedBoundaries[i+1]), 'MMM d, yy'),
                days,
                weeks: weeks.toFixed(3),
                season: season.season_name,
                cost
            });
          }
        }
      
        return {chunks, weeksTotal};
      }

    calculateDailyReservationCost(reservationStart, reservationEnd, seasons, daySpecificRatesStatus) {
        const chunks = [];
        console.log(this.state.dayChunks);
        let daysTotal = 0;
      
        this.state.dayChunks.forEach(chunk => {
          let currentDate = new Date(chunk.from);
          const toDate = new Date(chunk.to);
          const season = seasons.find(s => s.season_id === chunk.seasonId);
          if (!season) return;
      
          while (currentDate < toDate) {
            const nextDate = addDays(currentDate, 1);
            const dayIndex = currentDate.getDay();
            const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      
            let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
            daysTotal += cost;
      
            chunks.push({
              from: format(currentDate, 'MMM d, yy'),
              to: format(nextDate, 'MMM d, yy'),
              day: currentDate.toDateString(),
              season: season.season_name,
              cost
            });
      
            currentDate = nextDate;
          }
        });
      
        // Now handle main direct range
        let currentDate = new Date(reservationStart);
        const endDate = new Date(reservationEnd);
      
        while (currentDate < endDate) {
          const nextDate = addDays(currentDate, 1);
      
          const applicableSeasons = seasons.filter(season =>
            currentDate >= new Date(season.season_start) && currentDate <= new Date(season.season_end)
          );
      
          let season = applicableSeasons.sort(
            (a, b) =>
              (new Date(a.season_end) - new Date(a.season_start)) -
              (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1);
      
          const dayIndex = currentDate.getDay();
          const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      
          let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
          daysTotal += cost;
      
          chunks.push({
            from: format(currentDate, 'MMM d, yy'),
            to: format(nextDate, 'MMM d, yy'),
            day: currentDate.toDateString(),
            season: season.season_name,
            cost
          });
      
          currentDate = nextDate;
        }
      
        return {chunks, daysTotal};
    }

    discountChange = (event) => {
        console.log(JSON.stringify(event) + 'this is the event');
        console.log(this.state.daysTotal, this.state.weeksTotal, this.state.monthsTotal);
        let term = this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate);
        let subTotal = this.state.subTotalWithoutDiscount1;
        let subTotalWithoutDiscount = this.state.subTotalWithoutDiscount1;
        let discountTotal = null;
        // let selectedDiscount = this.state.discounts.find(
        //     (discount) => discount.name === event.target.value
        // );
        let selectedDiscount = this.state.discounts.find(
            (discount) => discount.name === event.target.value
        );
        console.log('this is subtotal wo discoutn', selectedDiscount);
        if (selectedDiscount != null) {
            if (selectedDiscount.amount > 0) {
                discountTotal = selectedDiscount.amount
                this.setState({
                    discountByPercent: false
                })
            } else if (selectedDiscount.amount_daily > 0 || selectedDiscount.amount_monthly > 0 || selectedDiscount.amount_weekly > 0) {
                if (term[2] > 0 && selectedDiscount.amount_monthly > 0) {
                    discountTotal += (term[2] * selectedDiscount.amount_monthly)
                }
                if (term[1] > 0 && selectedDiscount.amount_weekly > 0) {
                    discountTotal += (term[1] * selectedDiscount.amount_weekly)
                }
                if (term[0] > 0 && selectedDiscount.amount_daily > 0) {
                    discountTotal += (term[0] * selectedDiscount.amount_daily)
                }
                this.setState({
                    discountByPercent: false
                })
            } else {
                if (this.state.monthsTotal > 0 && selectedDiscount.disc_appl_month) {
                    discountTotal += (this.state.monthsTotal * selectedDiscount.discount_percent) / 100
                }
                if (this.state.weeksTotal > 0 && selectedDiscount.disc_appl_week) {
                    discountTotal += (this.state.weeksTotal * selectedDiscount.discount_percent) / 100
                }
                if (this.state.daysTotal > 0 && selectedDiscount.disc_appl_daily) {
                    discountTotal += (this.state.daysTotal * selectedDiscount.discount_percent) / 100
                }
                this.setState({
                    discountByPercent: true
                })
                console.log("this is the total discount calculated", discountTotal, this.state.daysTotal);
            }
            subTotal -= discountTotal
            subTotalWithoutDiscount -= discountTotal
        }
        console.log("this is the total discount calculated", discountTotal);
        if (this.state.oneTimeDiscount)
            subTotal -= this.state.oneTimeDiscount;
        this.setState({
            discount: selectedDiscount ? selectedDiscount : null,
            discountTotal: discountTotal,
            subTotal: subTotal,
            subTotalWithoutDiscount: subTotalWithoutDiscount,
            discount_id: selectedDiscount?.id ?? 0,
            // discountApplyDaily: selectedDiscount.disc_appl_daily === 1,
            // discountApplyWeek: selectedDiscount.disc_appl_week === 1,
            // discountApplyMonth: selectedDiscount.disc_appl_month === 1,
            // discountApplySeasonal: selectedDiscount.disc_appl_seasonal === 1,
            discountPercent: selectedDiscount?.discount_percent,
            // discountId: selectedDiscount.id,
            // discountAmountOnce: selectedDiscount.amount,
            // discountAmountDaily: selectedDiscount.amount_daily,
            // discountAmountWeekly: selectedDiscount.amount_weekly,
            // discountAmountMonthly: selectedDiscount.amount_monthly,
            reservationUpdated: true
        });
        this.calculateTaxAndTotal(subTotal, this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate), this.state.extraSubTotal);
    };

    offlineMethodChange = (event) => {
        this.setState({offlineMethod: event.target.value},() => { this.userDetailsValidation() })
    };

    toUTCDateOnly = (dateString) => {
        const date = new Date(dateString);
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }

    getDuration(checkIn, checkOut) {
        const startDate = this.toUTCDateOnly(checkIn);
        const endDate = this.toUTCDateOnly(checkOut);
        let months = 0, weeks = 0, days = 0;
        let tempDate = new Date(startDate);
        while (true) {
            const nextMonth = new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth() + 1, tempDate.getUTCDate()));
            if (nextMonth <= endDate) {
                months++;
                tempDate = nextMonth;
            } else {
                break;
            }
        }
        const remainingDays = Math.floor((endDate - tempDate) / (24 * 60 * 60 * 1000));
        weeks = Math.floor(remainingDays / 7);
        days = remainingDays % 7;
        return [days, weeks, months];
    }

    calculateTaxAndTotal = async (subTotal, term, additionalAmount) => {
        let taxes = await getTaxes(this.props.user, this.props.serverName);
        let selectedTaxes = await getSiteTaxes(this.props.user, this.props.serverName, this.state.sitetype_id)
        selectedTaxes = selectedTaxes[0]?.taxrate_ids ? selectedTaxes[0].taxrate_ids.split(',').map(id => Number(id.trim())) : [];
        if (!Array.isArray(selectedTaxes)) selectedTaxes = [];
        let totalAmount = 0.0;
        let tax = [];
        let taxPercent = [];
        let taxName = [];
        let convenienceFees = 0.0;
        let baseTotal = 0.0;
        let variableChargeTotal = 0.0;
        //taxes
        for (let index = 0; index < taxes.length; index++) {
            if (!selectedTaxes.includes(taxes[index].id))
                continue;
            const element = taxes[index];
            if (element.is_percent === 1) {
                let countedTax = 0.0;
                const formula = (element.percent / 100)
                if (element.apl_daily === 1 && this.state.daysTotal > 0) {
                    const total = this.state.daysTotal
                    countedTax += parseFloat((total * formula));
                }
                if (element.apl_week === 1 && this.state.weeksTotal > 0) {
                    const total = this.state.weeksTotal
                    countedTax += parseFloat((total * formula));
                }
                if (element.apl_month === 1 && this.state.monthsTotal > 0) {
                    const total = this.state.monthsTotal
                    countedTax += parseFloat((total * formula));
                }
                if (element.apl_seasonal === 1 && this.state.seasonTotal > 0) {
                    const total = this.state.seasonTotal
                    countedTax += parseFloat((total * formula).toFixed(2));
                }
                if (countedTax > 0) {
                    if (additionalAmount > 0) {
                        const total = additionalAmount
                        countedTax += parseFloat((total * formula).toFixed(2));
                    }
                    if (this.state.discountTotal > 0) {
                        const total = this.state.discountTotal
                        countedTax -= parseFloat((total * formula));
                    }
                    for (let index = 0; index < this.state.variableCharges.length; index++) {
                        if (this.state.variableCharges[index].taxable)
                            countedTax += parseFloat(this.state.variableCharges[index].amount * formula);
                    }
                    taxPercent[index] = element.percent;
                    tax[index] = countedTax.toFixed(2);
                    taxName[index] = element.name;
                }
            } else {
                let totalDays = term[0];
                if (element.apl_month === 1) {
                    if (element.monthly_charge_daily === 1) {
                        totalDays = totalDays + (term[2] * 30)
                    } else {
                        taxPercent[index] = element.amount;
                        tax[index] = (term[2] * element.amount)
                        taxName[index] = element.name;
                    }
                } else if (element.apl_week === 1) {
                    if (element.weekly_charge_daily === 1) {
                        totalDays = totalDays + (term[1] * 7)
                    } else {
                        taxPercent[index] = element.amount;
                        tax[index] = (term[1] * element.amount)
                        taxName[index] = element.name;
                    }
                }
                taxPercent[index] = element.amount;
                tax[index] = (totalDays * element.amount)
                taxName[index] = element.name;
            }
        }

        totalAmount = subTotal;
        for (let index = 0; index < tax.length; index++) {
            if (tax[index] !== undefined) {
                totalAmount += parseFloat(tax[index]);
            }
        }
        baseTotal = totalAmount
        if (this.state.variableCharges.length > 0) {
            for (let index = 0; index < this.state.variableCharges.length; index++) {
                variableChargeTotal += parseFloat(this.state.variableCharges[index].amount);
            }
        }
        if ((this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') && this.state.selectedPaymentValue === 'fullPayment') {
            convenienceFees = (((parseFloat(totalAmount.toFixed(2)) + parseFloat(variableChargeTotal.toFixed(2))) - this.state.totalPaidAmount.toFixed(2)) * this.state.convenienceFees / 100);
        }
        let amountToPay = (parseFloat(totalAmount.toFixed(2)) + parseFloat(variableChargeTotal.toFixed(2))) - parseFloat(this.state.totalPaidAmount.toFixed(2))

        let totalTaxAmount = 0.0
        for (let index = 0; index < tax.length; index++) {
            totalTaxAmount = totalTaxAmount + parseFloat(tax[index]);
        }
        if (this.state.reservationUpdated) {
            let updateReservationTotalResponse = await updateReservationTotal(this.props.user, this.props.serverName, totalTaxAmount,
                this.state.subTotalWithoutDiscount1 + variableChargeTotal, this.props.viewItem.id, this.state.oneTimeDiscount, this.state.discount_id)
        }

        this.setState({
            amtToPay: amountToPay,
            totalPayableAmt: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? (parseFloat(amountToPay) + parseFloat(convenienceFees)).toFixed(2) : parseFloat(amountToPay),
            taxes: taxes,
            totalAmount: parseFloat(totalAmount.toFixed(2)) + parseFloat(variableChargeTotal.toFixed(2)),
            tax: tax,
            taxPercent: taxPercent,
            taxName: taxName,
            convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees.toFixed(2) : null,
            baseTotal: baseTotal.toFixed(2),
            oldVariableCharge: variableChargeTotal,
            waitForCalculations: false,
            totalTaxAmount: totalTaxAmount
        })
    }

    handlePaymentSelect = (value) => {
        let convenienceFees = 0.0
        let partialTotal = 0.0
        let balance = 0.0
        let totalAmount = 0.0
        if (value === 'cash' || value === 'check') {
            this.setState({
                convenienceCharge: convenienceFees,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'partialPayment') {
            balance = 0.0
            convenienceFees = (this.state.amtToPay * this.state.convenienceFees / 100);
            console.log("Partial Pay")
            console.log("amt to pay: ", this.state.amtToPay)
            console.log("Convenience charge: ", convenienceFees)
            this.setState({
                partialBase: this.state.amtToPay,
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees : null,
                partialTotal: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? parseFloat(this.state.amtToPay) + parseFloat(convenienceFees) : parseFloat(this.state.amtToPay),
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'fullPayment') {
            convenienceFees = (this.state.amtToPay * this.state.convenienceFees / 100);
            console.log("Full payment")
            console.log("amt to pay: ", this.state.amtToPay)
            console.log("Convenience charge: ", convenienceFees)
            this.setState({
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees : null,
                totalPayableAmt: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? this.state.amtToPay + convenienceFees : this.state.amtToPay,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'ccPOS') {
            convenienceFees = (this.state.baseTotal * this.state.convenienceFees / 100);
            totalAmount = parseFloat(this.state.baseTotal) + parseFloat(convenienceFees.toFixed(2))
            this.setState({
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenienceFees : null,
                totalAmount: parseFloat(this.state.baseTotal),
                ccPOSAmount: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ?
                    ((parseFloat(this.state.baseTotal) - parseFloat(this.state.totalPaidAmount).toFixed(2)) + convenienceFees).toFixed(2) : (parseFloat(this.state.baseTotal) - parseFloat(this.state.totalPaidAmount).toFixed(2)),
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        } else if (value === 'others') {
            this.setState({
                convenienceCharge: convenienceFees,
                selectedPaymentValue: value
            },
            () => {
                this.userDetailsValidation();
            })
        }
    }

    amountChange = (event) => {
        if (this.state.selectedPaymentValue === 'check' || this.state.selectedPaymentValue === 'cash' || this.state.selectedPaymentValue === 'ccPOS' || this.state.selectedPaymentValue === 'others') {
            if(event.target.id === 'offlineLast4')
                {
                    if (/^\d{0,4}$/.test(event.target.value)) {
                        this.setState({ offlineLast4: event.target.value },() => {
                            this.userDetailsValidation();
                        });
                      }
                }
            else{
                this.setState({
                    [event.target.id]: event.target.value
                },() => {
                    this.userDetailsValidation();
                })
            }
        }
        else {
            let convenience = 0.0
            let totalPartialAmount = 0.0

            convenience = ((event.target.value * this.state.convenienceFees) / 100)
            totalPartialAmount = parseFloat(event.target.value) + parseFloat(convenience.toFixed(2))
            this.setState({
                partialBase: event.target.value,
                convenienceCharge: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? convenience.toFixed(2) : null,
                partialTotal: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? totalPartialAmount.toFixed(2) : parseFloat(event.target.value),
                // totalAmount: this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? parseFloat(this.state.baseTotal) + parseFloat(convenience.toFixed(2)) : parseFloat(this.state.baseTotal)
            })
        }
    }

    getDays = () => {
        const msPerDay = 24 * 60 * 60 * 1000;
        const startDate = new Date(this.props.viewItem.startdate);
        const endDate = new Date(this.props.viewItem.enddate);
        let totalDays = Math.floor((endDate - startDate) / msPerDay);
        return totalDays;
    }

    addExtra = async (extra, count, index) => {
        let extraTotal = 0;
        let totalDays = this.getDays();
        let duration = this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate)
        let finalCount
        let extraAmount = 0;
        if (extra.extra_type === 0) {
            let tempTotal = 0
            if (duration[2] > 0) {
                tempTotal = tempTotal + (duration[2] * extra.monthly)
            }
            if (duration[1] > 0) {
                tempTotal = tempTotal + (duration[1] * extra.weekly)
            }
            if (duration[0]) {
                tempTotal = tempTotal + (duration[0] * extra.daily);
            }
            extraTotal = tempTotal
            finalCount = totalDays
            extraAmount = tempTotal
        } else if (extra.extra_type === 1) {
            extraTotal = (count * totalDays * extra.daily)
            finalCount = count * totalDays
            extraAmount = (count * totalDays * extra.daily)
        } else if (extra.extra_type === 2) {
            extraTotal = ((this.state.end[index] - this.state.start[index]) * extra.rate)
            finalCount = (this.state.end[index] - this.state.start[index])
            extraAmount = ((this.state.end[index] - this.state.start[index]) * extra.rate)
            //update space.current to end value
            let updateCurrentResponse = await updateSpaceCurrent(this.props.user, this.props.serverName, this.props.viewItem.sitename, this.state.end[index])
        } else if (extra.extra_type === 3) {
            extraTotal = (count * extra.charge)
            finalCount = count
            extraAmount = (count * extra.charge)
        } else {
            extraTotal = extra.charge
            finalCount = ''
            extraAmount = extra.charge
        }
        this.setState({
            reservationUpdated: true,
            subTotalWithoutDiscount1: this.state.subTotalWithoutDiscount1 + extraTotal,
        })
        this.calculateTaxAndTotal(this.state.subTotal + extraTotal, duration, this.state.extraSubTotal + extraTotal);

        //add extra to database
        let days = this.getDays();
        console.log("extra.id: ", extra.id)
        let extraResponse = await addExtras(this.props.user, this.props.serverName, extra.id, this.props.viewItem.id, finalCount,
            days, extraAmount, format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
        let subtotal = this.state.subTotal + extraTotal;
        let subTotalWithoutDiscount = this.state.subTotalWithoutDiscount + extraTotal;
        let subTotalWithoutDiscount1 = this.state.subTotalWithoutDiscount1 + extraTotal;

        this.setState({
            subTotal: subtotal,
            subTotalWithoutDiscount: subTotalWithoutDiscount,
            subTotalWithoutDiscount1: subTotalWithoutDiscount1,
            selectedExtras: [...this.state.selectedExtras, extra.name],
            selectedExtraCount: [...this.state.selectedExtraCount, finalCount],
            selectedExtraAmount: [...this.state.selectedExtraAmount, extraAmount],
            selectedExtrasTypeId: [...this.state.selectedExtrasTypeId, extra.extra_type],
            extraSubTotal: this.state.extraSubTotal + extraAmount,
            extraId: [...this.state.extraId, extra.id],
            extraPopup: true,
            extraPopupTitle: 'Add-Ons added successfully!'
        })
    }

    handleCountChange = (index, event) => {
        const newCounts = { ...this.state.counts, [index]: event.target.value };
        this.setState({ counts: newCounts });
    };

    handleStartEnd = (event, index) => {
        this.setState((prevState) => {
            const updatedArray = [...prevState[event.target.id]];
            updatedArray[index] = event.target.value;

            return {
                [event.target.id]: updatedArray
            };
        }, () => {
            this.validateAddOns(index);
        });
    }

    validateAddOns = (index) => {
        if (this.state.start[index] > 0 && this.state.end[index] > 0 && this.state.end[index] > this.state.start[index]) {
            this.setState({
                type2Add: true
            })
        } else if (this.state.type2Add) {
            this.setState({
                type2Add: false
            })
        }
    }

    userDetailsValidation = () => {
        if (this.state.selectedPaymentValue === 'check') {
            if (this.state.checkAmount && this.state.checkNumber) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        } else if (this.state.selectedPaymentValue === 'others') {
            if (this.state.offlineMethod && this.state.offlineAmount && this.state.offlinePaymentDate) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        } else if (this.state.selectedPaymentValue === 'cash') {
            if (this.state.cashAmount) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        } else {
            if ((this.state.cardNumber.length == 16 || this.state.cardNumber.length == 15) && this.state.cardOwner && this.state.expiryMonth.length == 2 &&
                this.state.expiryYear.length == 2 && (this.state.cvv.length == 3 || this.state.cvv.length == 4) && this.state.address && this.state.city && this.state.state && this.state.zip) {
                this.setState({
                    userDetailsFormValid: true
                })
            } else if (this.state.userDetailsFormValid) {
                this.setState({
                    userDetailsFormValid: false
                })
            }
        }
    }

    handleStripeSuccess = async (paymentIntent) => {
        let amount;
        let taxtotal = 0.0;
        this.setState({
            open2: true,
        })
        console.log(paymentIntent,'this the payment intent');
        const cardDetails = await getPaymentMethod(paymentIntent.payment_method);
        console.log(cardDetails,'these are the card details');
        if (this.state.selectedPaymentValue === 'fullPayment') {
            amount = this.state.totalAmount - this.state.totalPaidAmount
        } else {
            amount = this.state.partialTotal
        }
        amount = parseFloat(amount).toFixed(2);
        if (paymentIntent.status === "succeeded") {
            let cardId = await getCardType(cardDetails.brand)
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, this.props.viewItem.id, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), paymentIntent.id,
                    cardId, cardDetails.last4, this.state.cardOwner, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, paymentIntent.payment_method)
            console.log("payment record: ", paymentRecords)
            this.setState({
                open2: false,
                open: true,
                popupText: 'Payment successful.'
            })
            } else {
                this.setState({
                    open2: false,
                    open: true,
                    popupText: 'Payment declined. Please try again.'
                })
            }
    };

    handleStripeFail = async (message) => {
        this.setState({
            open2: false,
            open: true,
            popupText: `Payment declined. ${message}.`
        })
    };

    pay = async () => {
        let amount;
        let taxtotal = 0.0;
        this.setState({
            open2: true,
        })
        //tax
        for (let index = 0; index < this.state.tax.length; index++) {
            taxtotal = taxtotal + parseFloat(this.state.tax[index]);
        }

        if (this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') {
            amount = this.state.totalAmount
            if (this.state.selectedPaymentValue === 'fullPayment') {
                amount = this.state.totalAmount - this.state.totalPaidAmount
            } else {
                amount = this.state.partialTotal
            }

            if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') {
                if (this.state.selectedPaymentValue === 'fullPayment') {
                    amount = parseFloat(amount) + parseFloat(this.state.convenienceCharge)
                    console.log("amount: ", amount)
                } else {
                    console.log("amount: ", amount)
                }
                let payment
                if (this.state.payWithSavedCard) {
                    payment = await makeVaultedPayment(this.state.paymentIntegration.cp_merchantid, amount, this.state.paymentToken)
                    // payment = await makeVaultedPayment('1000017768', amount, this.state.paymentToken)
                    console.log("Payment Response: ", payment)
                } else {
                    // payment = await makePayment('1000017768', amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear, this.state.cvv, this.state.zip, this.state.address)
                    payment = await makePayment(this.state.paymentIntegration.cp_merchantid, amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear, this.state.cvv, this.state.zip, this.state.address)
                    console.log("payment: ", payment)
                }

                if (payment.status === 'Approved') {
                    let cardId = await getCardType(payment.cardAccount.cardType)
                    let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, this.props.viewItem.id, payment.created, payment.created, payment.reference, cardId,
                        payment.cardAccount.last4, this.state.cardOwner, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, payment.cardAccount.token)
                    if (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid) {
                        let response2 = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'edited')
                    }
                    let updateReservationTotalResponse = await updateReservationTotal(this.props.user, this.props.serverName, this.state.totalTaxAmount,
                        (this.state.subTotalWithoutDiscount1 + this.state.oldVariableCharge + parseFloat(this.state.convenienceCharge)), this.props.viewItem.id, this.state.oneTimeDiscount, this.state.discount_id)
                    let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, this.props.viewItem.id, "Service Fees", this.state.convenienceCharge, new Date(), new Date())
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment successful.'
                    })
                } else {
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment declined. Please try again.'
                    })
                }
            } else if (this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o') {
                amount = parseFloat(amount).toFixed(2);
                let paymentResponse = await cardConnectPaymemt(this.props.user, this.state.paymentIntegration.cc_merchant_id, amount, this.state.cardNumber, this.state.expiryMonth, this.state.expiryYear,
                    this.state.cvv, this.state.zip, this.state.address, this.state.fname, this.state.city, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                console.log("payment: ", paymentResponse)
                if (paymentResponse.respstat === "A") {
                    let cardId = await getCardType(paymentResponse.binInfo.product)
                    let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, this.props.viewItem.id, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), paymentResponse.retref,
                        cardId, paymentResponse.account.slice(-4), this.state.cardOwner, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1, paymentResponse.token)
                    if (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) {
                        let response2 = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'edited')
                    }
                    console.log("payment record: ", paymentRecords)
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment successful.'
                    })
                } else {
                    this.setState({
                        open2: false,
                        open: true,
                        popupText: 'Payment declined. Please try again.'
                    })
                }
            }
        } else if (this.state.selectedPaymentValue === 'cash') {
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.cashAmount, this.props.viewItem.id, format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                format(new Date(), 'yyyy-MM-dd HH:mm:ss'), "Cash Payment", "1", "", this.state.fname + " " + this.state.lname, this.state.cashDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'cash')
            console.log("payment record: ", paymentRecords)
            this.setState({
                open2: false,
                open: true,
                popupText: 'Cash payment recorded successfully.'
            })
        } else if (this.state.selectedPaymentValue === 'check') {
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.checkAmount, this.props.viewItem.id, format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                format(new Date(), 'yyyy-MM-dd HH:mm:ss'), "Check Payment: " + this.state.memo, "2", "", this.state.fname + " " + this.state.lname, this.state.checkDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'check')
            console.log("payment record: ", paymentRecords)
            this.setState({
                open2: false,
                open: true,
                popupText: 'Check payment recorded successfully.'
            })
        } else if (this.state.selectedPaymentValue === 'ccPOS') {
            this.setState({
                open2: false,
                open1: true,
                popupText1: 'We’re now communicating with the card terminal. Please follow the instructions on the terminal to complete your payment. Do not close this window or navigate away until the payment is complete.'
            })
            let popupText
            if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o') {
                //call jwt api
                let getJWTTokenResponse = await getJWTToken(this.state.paymentIntegration.cp_merchantid)
                console.log("JWT Token: ", getJWTTokenResponse.jwtToken)

                //call get list of terminal api with received jwt token
                let getListOfTerminalsResponse = await getListOfTerminals(this.state.paymentIntegration.cp_merchantid, getJWTTokenResponse.jwtToken)
                console.log('Terminal ID: ', getListOfTerminalsResponse[0].id)

                //call getReplayID api
                let replayID = await getReplayID(this.props.user, this.props.serverName)
                console.log("ReplayId: ", replayID[0].replayID)

                //call updateReplayID api
                let updateReplayIDResponse = await updateReplayID(this.props.user, this.props.serverName)
                console.log("Update ReplayId response: ", updateReplayIDResponse)

                //call create terminal payment api
                let createTerminalPaymentResponse = await createTerminalPayment(this.state.paymentIntegration.cp_merchantid, getJWTTokenResponse.jwtToken, this.state.ccPOSAmount, getListOfTerminalsResponse[0].id, replayID[0].replayID)
                console.log("createTerminalPaymentResponse: ", createTerminalPaymentResponse)

                //terminal transaction get to get the reference number
                let getTerminalTransactionResponse = await getTerminalTransaction(this.state.paymentIntegration.cp_merchantid, replayID[0].replayID)
                // let getTerminalTransactionResponse = await getTerminalTransaction(this.state.paymentIntegration.cp_merchantid, 54)
                console.log("getTerminalTransactionResponse: ", getTerminalTransactionResponse)

                //record payment
                if (getTerminalTransactionResponse === null) {
                    popupText = 'No Response from POS Terminal.'
                } else {
                    if (getTerminalTransactionResponse.status === 'Approved') {
                        let cardId = await getCardType(getTerminalTransactionResponse.cardAccount.cardType)
                        console.log("CardId: ", cardId)
                        await recordPayment(this.props.user, this.props.serverName, getTerminalTransactionResponse.amount, this.props.viewItem.id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), "POS Terminal: " + getTerminalTransactionResponse.reference,
                            cardId, getTerminalTransactionResponse.cardAccount.last4, "", format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1)
                        let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, this.props.viewItem.id, "Service Fees", this.state.convenienceCharge, new Date(), new Date())
                        let totalTaxAmount = 0.0
                        for (let index = 0; index < this.state.tax.length; index++) {
                            totalTaxAmount = totalTaxAmount + parseFloat(this.state.tax[index]);
                        }
                        let updateReservationTotalResponse = await updateReservationTotal(this.props.user, this.props.serverName, totalTaxAmount,
                            this.state.subTotal + this.state.convenienceCharge, this.props.viewItem.id, this.state.oneTimeDiscount, this.state.discount_id)
                        popupText = 'POS terminal payment added successfully.'
                    } else {
                        popupText = 'POS terminal payment declined. Please try again.'
                    }
                }

                this.setState({
                    open1: false,
                    open: true,
                    popupText: popupText
                })
            } else {
                //get list of terminals
                let listOfTerminals = await cardConnectGetListOfTerminals(this.props.user, this.state.paymentIntegration.cc_merchant_id)

                //connect
                let connectToTerminalResponse = await cardConnectConnectToTerminal(this.props.user, this.state.paymentIntegration.cc_merchant_id, listOfTerminals.terminals[0])

                if (connectToTerminalResponse.status === 200) {
                    //authcard
                    let paymentResponse = await cardConnectTerminalPayment(this.props.user, this.state.paymentIntegration.cc_merchant_id, listOfTerminals.terminals[0],
                        this.state.ccPOSAmount * 100, connectToTerminalResponse.SessionKey)
                    console.log("Payment Response: ", paymentResponse)
                    if (paymentResponse.errorCode === 8) {
                        popupText = 'Payment cancelled by user.'
                    } else if (paymentResponse.resptext === 'Approval') {
                        let cardId = await getCardType(paymentResponse.binInfo.product)
                        await recordPayment(this.props.user, this.props.serverName, this.state.ccPOSAmount, this.props.viewItem.id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'), "POS Terminal: " + paymentResponse.retref,
                            cardId, "", "", format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 1)
                        if (this.state.paymentIntegration.name == 'None' || (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) || (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid)) {
                            let response2 = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'edited')
                        }
                        popupText = 'POS terminal payment added successfully.'
                    } else {
                        popupText = 'POS terminal payment declined. Please try again.'
                    }
                } else {
                    popupText = 'Cannot connect to POS terminal. Please try again.'
                }
                this.setState({
                    open1: false,
                    open: true,
                    popupText: popupText
                })
            }
        } else if (this.state.selectedPaymentValue === 'others') {
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, this.state.offlineAmount, this.props.viewItem.id, format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                format(new Date(), 'yyyy-MM-dd HH:mm:ss'), `${this.state.offlineMethod}: ${this.state.offlineMemo||''}`, "7", this.state.offlineLast4, this.state.fname + " " + this.state.lname, this.state.offlinePaymentDate.format('YYYY-MM-DD'), 1)
            let response = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'offlinePayment')
            console.log("payment record: ", paymentRecords)
            this.setState({
                open2: false,
                open: true,
                popupText: 'payment recorded successfully.'
            })
        }
    }

    checkIn = async () => {
        let reservationCheckIn = await checkIn(this.props.user, this.props.serverName, this.props.viewItem.id)
        this.props.goBack();
    }

    checkOut = async () => {
        let reservationCheckOut = await checkOut(this.props.user, this.props.serverName, this.props.viewItem.id)
        let mailmessage = this.replaceMailTemplatePlaceHolders("feedback")
        let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.props.viewItem.email, this.state.reservationFeedbackSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.feedbackAttachments)
        this.props.goBack();
    }

    sendReservationUpdate = async () => {
        let mailmessage = this.replaceMailTemplatePlaceHolders("update")
        let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.props.viewItem.email, this.state.reservationUpdateMailSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.updateAttachments)
        // this.props.goBack();
        this.setState({
            Popup3DialogTitle: "Update Email Sent",
            popup3Text: "We have notified the guest that their reservation has been updated.",
            open3: true
        })
    }

    replaceMailTemplatePlaceHolders = (type) => {
        let mailMessage
        if (type === "feedback") {
            mailMessage = this.state.reservationFeedbackMailMessage
        } else if (type === "update") {
            mailMessage = this.state.reservationUpdateMailMessage
        } else {
            mailMessage = this.state.reservationCancelMailMessage
        }
        if (type === "cancel") {
            mailMessage = mailMessage.replace('{{reason}}', reasonMap[this.state.cancellationReason] || "Unknown reason");
        }
        mailMessage = mailMessage.replace(/{{camper}}/g, this.props.viewItem.first_name + ' ' + this.props.viewItem.last_name);
        mailMessage = mailMessage.replace(/{{number}}/g, this.props.viewItem.id);
        mailMessage = mailMessage.replace(/{{start}}/g, this.props.viewItem.startdate);
        mailMessage = mailMessage.replace(/{{departure}}/g, this.props.viewItem.enddate);
        mailMessage = mailMessage.replace(/{{space_name}}/g, this.props.viewItem.sitename);
        // mailMessage = mailMessage.replace('{{charges}}', this.props.viewItem.total || 0 + this.props.viewItem.tax || 0);
        mailMessage = mailMessage.replace(/{{charges}}/g, this.state.totalAmount || (this.props.viewItem.total || 0 + this.props.viewItem.tax || 0));
        mailMessage = mailMessage.replace(/{{deposit}}/g, this.props.viewItem.deposit || 0);
        const value = (
            parseFloat(this.props.viewItem.total || 0) +
            parseFloat(this.props.viewItem.tax_amount || 0) -
            parseFloat(this.props.viewItem.amount_paid || 0)
        );

        const formattedValue = value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
        mailMessage = mailMessage.replace(/{{due}}/g, formattedValue);
        mailMessage = mailMessage.replace(/{{created}}/g, this.props.viewItem.created_at.slice(0, 10));
        return mailMessage
    }

    replaceMessageReject = () => {
        let mailMessage = this.state.remoteResRejectedMailMessage
        mailMessage = mailMessage.replace(/{{camper}}/g, this.props.viewItem.first_name + ' ' + this.props.viewItem.last_name);
        mailMessage = mailMessage.replace(/{{start}}/g, this.props.viewItem.startdate);
        mailMessage = mailMessage.replace(/{{departure}}/g, this.props.viewItem.enddate);
        console.log(mailMessage)
        return mailMessage
    }

    cancel = async () => {
        let reservationCancel = await cancel(this.props.user, this.props.serverName, this.props.viewItem.id)
        if (this.props.viewItem.unconfirmed_remote === 1) {
            let mailmessage = this.replaceMessageReject()
            let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.props.viewItem.emailId, this.state.remoteResRejectedSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.rejectedAttachments)
        } else {
            let mailmessage = this.replaceMailTemplatePlaceHolders("cancel")
            const createdAt = dayjs(this.props.viewItem.created_at);
            const now = dayjs();
            const isWithin24hours = now.diff(createdAt, 'hour') <= 24;
            let response = await addCancellationCharge(this.props.user, this.props.serverName, this.props.viewItem.id, this.state.cancellationCharge, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
            let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.props.viewItem.email, this.state.reservationCancelSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.cancelAttachments)
            if (!isWithin24hours) {
                let response2 = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'cancel')
            }
            else {
                let response2 = await deleteSystemFeeRecord(this.props.serverName, this.props.viewItem.id)
            }
        }
        this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=transactions&searchValue=${this.props.viewItem.id}`)
        // this.props.goBack();
    }

    replaceMessageConfirm = () => {
        let mailMessage = this.state.remoteResConfirmedMailMessage
        mailMessage = mailMessage.replace(/{{camper}}/g, this.props.viewItem.first_name + ' ' + this.props.viewItem.last_name);
        mailMessage = mailMessage.replace(/{{number}}/g, this.props.viewItem.id);
        mailMessage = mailMessage.replace(/{{space_name}}/g, this.props.viewItem.sitename);
        mailMessage = mailMessage.replace(/{{start}}/g, this.props.viewItem.startdate);
        mailMessage = mailMessage.replace(/{{departure}}/g, this.props.viewItem.enddate);
        mailMessage = mailMessage.replace(/{{charges}}/g, this.props.viewItem.total + this.props.viewItem.tax_amount);
        return mailMessage
    }

    confirm = async () => {
        let reservationCancel = await confirmReservation(this.props.user, this.props.serverName, this.props.viewItem.id)
        if (this.state.paymentIntegration.name == 'None' || (this.state.paymentIntegration.name.includes('CardConnect') && !this.state.paymentIntegration.cc_merchant_id) || (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid)) {
            let response2 = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'created')
        }
        let mailmessage = this.replaceMessageConfirm()
        let mailResponse = await sendMail(this.props.user, this.props.serverName, this.state.sender, this.state.customerDetails.email, this.state.remoteResConfirmedSubject, mailmessage, this.state.reply, this.state.cc, this.state.bcc, this.state.confirmedAttachments)
        this.props.goBack();
    }

    handlePaymentDetailsChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value
        }, () => {
            this.userDetailsValidation();
        })
    }

    deleteExtra = async (index) => {
        this.setState({
            reservationUpdated: true
        })
        let term = this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate);
        this.calculateTaxAndTotal(this.state.subTotal - this.state.selectedExtraAmount[index], term, this.state.extraSubTotal - this.state.selectedExtraAmount[index]);
        let array1 = [...this.state.selectedExtras];
        let array2 = [...this.state.selectedExtraCount];
        let array3 = [...this.state.selectedExtraAmount];
        let array4 = [...this.state.selectedExtrasTypeId];
        array1.splice(index, 1);
        array2.splice(index, 1);
        array3.splice(index, 1);
        array4.splice(index, 1);
        let deleteResponse = await deleteAddedExtra(this.props.user, this.props.serverName, this.state.extraId[index])
        this.setState({
            selectedExtras: array1,
            selectedExtraCount: array2,
            selectedExtraAmount: array3,
            selectedExtrasTypeId: array4,
            extraSubTotal: this.state.extraSubTotal - this.state.selectedExtraAmount[index],
            subTotal: this.state.subTotal - this.state.selectedExtraAmount[index],
            subTotalWithoutDiscount: this.state.subTotalWithoutDiscount - this.state.selectedExtraAmount[index],
            subTotalWithoutDiscount1: this.state.subTotalWithoutDiscount1 - this.state.selectedExtraAmount[index],
            extraPopup: true,
            extraPopupTitle: 'Add-Ons deleted successfully!'
        });
    }

    deleteVariableCharge = async (index) => {
        console.log("extra id: ", this.state.variableCharges[index])
        this.setState({
            reservationUpdated: true
        })
        let deleteResponse = await deleteAddedVariableCharge(this.props.user, this.props.serverName, this.state.variableCharges[index].id)
        let array1 = [...this.state.variableCharges];
        array1.splice(index, 1);
        this.setState({
            variableCharges: array1,
            // subTotal: this.state.subTotal,
        });
        // this.calculateTaxAndTotal(this.state.subTotal, this.getDuration(this.props.checkIn, this.props.checkOut), this.state.extraSubTotal);
        this.calculateTaxAndTotal(this.state.subTotal, this.getDuration(this.props.viewItem.checkIn, this.props.viewItem.checkOut), this.state.extraSubTotal);
    }

    popupClose = async () => {
        this.setState({
            open: false
        }, () => {
            this.props.goBack()
        })
    }

    popup3Close = async () => {
        this.setState({
            open3: false
        }, () => {
            this.props.goBack()
        })
    }

    userDetailsChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value
        })
    }

    updateCustomerDetails = async () => {
        this.setState({
            disabledTextFields: true
        })
        let customerUpdateResponse = await customerDetailChanges(this.props.user, this.props.serverName, this.state.fname, this.state.lname, this.state.emailId, this.state.phoneNumber,
            this.state.address, this.state.city, this.state.state, this.state.zip, this.props.viewItem.camper_id);
        console.log(customerUpdateResponse)
    }

    updateInternalNotes = async () => {
        this.setState({
            disabledInternalNotes: true
        })
        let changesResponse = await internalNotesChanges(this.props.user, this.props.serverName, this.state.internalNote, this.props.viewItem.id)
        console.log(changesResponse)
    }

    changeSpace = async () => {
        let spacesData = await editReservationDates(this.props.user, this.props.serverName, this.state.editedEndDate, this.state.editedStartDate, this.props.viewItem.id);
        console.log("spacesData: ", spacesData)
        this.setState({
            spaceData: spacesData,
            chnageSpaceTitle: "Change space for reservation number: " + this.props.viewItem.id + " for date range from " + this.state.editedStartDate + " to " + this.state.editedEndDate,
            showNewSpaces: true
        })
    }

    newSpaceSelected = async (space) => {
        console.log("new space selected: ", space)
        this.setState({
            monthChunks: [],
            weekChunks: [],
            dayChunks: []
        })
        let seasons = await getAllseasons(this.props.user, this.props.serverName, this.state.editedStartDate, this.state.editedEndDate, space.space_name)
        const daySpecificRatesStatus = await getVariableRatesStatus(this.props.user, this.props.serverName)
        let monthDate = new Date(this.state.editedStartDate,);
        let subTotal = 0.0
        let subTotalWithoutDiscount = 0.0;
        let subTotalWithoutDiscount1 = 0.0;
        let seasonTotal = 0;
        let monthsTotal = 0
        let weeksTotal = 0
        let daysTotal = 0
        let daily = ''
        let weekly = ''
        let monthly = ''
        let seasonal = ''
        let discountTotal = null
        let selectedDiscount
        let sunday = ''
        let monday = ''
        let tuesday = ''
        let wednesday = ''
        let thursday = ''
        let friday = ''
        let saturday = ''
        let monthChunks = [];
        let weekChunks = [];
        let dayChunks = [];
        if(seasons.length>1){
            this.setState({
                blended: true
            })
        }
        daily = space.daily_rate
        weekly = space.weekly_rate
        monthly = space.monthly_rate
        seasonal = space.seasonal_rate
        sunday = space.sunday
        monday = space.monday
        tuesday = space.tuesday
        wednesday = space.wednesday
        thursday = space.thursday
        friday = space.friday
        saturday = space.saturday
        const daySpecificRates = {
            0: sunday,
            1: monday,
            2: tuesday,
            3: wednesday,
            4: thursday,
            5: friday,
            6: saturday
        };
        let term = this.getDuration(this.state.editedStartDate, this.state.editedEndDate);
        if (this.props.viewItem.seasonal === 1) {
            seasonTotal = seasonal
            subTotal += seasonTotal
        } else {
            // if (term[2] > 0) {
            //     if (monthly > 0) {
            //         monthsTotal = (term[2] * monthly);
            //         subTotal += monthsTotal;
            //     } else {
            //         let totalDaysFromMonths = 0;
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(this.state.editedStartDate);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             const monthDays = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
            //             totalDaysFromMonths += monthDays;
            //         }
            //         // term[1] = term[1] + (totalDaysFromMonths / 7);
            //         // term[2] = 0;
            //         const weeksFromMonths = Math.floor(totalDaysFromMonths / 7);
            //         const leftoverDays = totalDaysFromMonths % 7;
            //         term[1] += weeksFromMonths;
            //         term[0] += leftoverDays;
            //     }
            // }
            // if (term[1] > 0) {
            //     if (weekly > 0) {
            //         weeksTotal = ((term[1]) * weekly);
            //         subTotal += weeksTotal;
            //     } else {
            //         term[0] = term[0] + (term[1] * 7);
            //         term[1] = 0
            //     }
            // }
            // if (term[0] > 0) {
            //     if(this.state.daySpecificRatesStatus){
            //         let checkInDate = new Date(this.state.editedStartDate);
            //         let daysToAdvance = 0;
            //         let baseDate = new Date(this.state.editedStartDate);
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(baseDate);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             let year = monthDate.getFullYear();
            //             let month = monthDate.getMonth();
            //             let daysInMonth = new Date(year, month + 1, 0).getDate();
            //             daysToAdvance += daysInMonth;
            //         }
            //         checkInDate.setDate(checkInDate.getDate() + daysToAdvance);
            //         for (let i = 0; i < term[0]; i++) {
            //             const dayOfWeek = checkInDate.getUTCDay();
            //             console.log('the day of thee week', dayOfWeek);
            //             const dayspecificrate = daySpecificRates[dayOfWeek] ?? this.props.daily ?? 0;
            //             console.log(`the day of thee week ${dayOfWeek} and its price ${dayspecificrate} ${this.props.sunday} ${this.props.Saturday}`);
            //             daysTotal += dayspecificrate;
            //             subTotal += dayspecificrate;
            //             subTotalWithoutDiscount += dayspecificrate;
            //             checkInDate.setDate(checkInDate.getDate() + 1);
            //         }}
            //     else{
            //     daysTotal = (Math.round(term[0]) * daily);
            //     subTotal += daysTotal;
            //     subTotalWithoutDiscount += daysTotal;
            //     }
            // }
            if(term[2]){
                let monthEndDate = new Date(monthDate);
                monthEndDate.setMonth(monthEndDate.getMonth() + term[2]);
                // monthDate.setMonth(monthDate.getMonth() + term[2]);
                monthChunks = this.calculateReservationCost(monthDate, monthEndDate, seasons, term[2])
                monthsTotal = monthChunks.monthsTotal;
                subTotal += monthChunks.monthsTotal;
                subTotalWithoutDiscount += monthChunks.monthsTotal;
                monthDate.setMonth(monthDate.getMonth() + term[2]);
                console.log(JSON.stringify(monthChunks));
            }
            if(term[1]){
                let weekEndDate = new Date(monthDate);
                weekEndDate.setDate(weekEndDate.getDate() + term[1] * 7);
                weekChunks = this.calculateWeeklyReservationCost(monthDate, weekEndDate, seasons)
                weeksTotal = weekChunks.weeksTotal
                subTotal += weekChunks.weeksTotal;
                subTotalWithoutDiscount += weekChunks.weeksTotal
                monthDate.setDate(monthDate.getDate() + term[1] * 7);
                console.log(JSON.stringify(weekChunks));
            }
            if(term[0] || this.state.dayChunks.length){
                let endDate = new Date(this.state.editedEndDate);
                dayChunks = this.calculateDailyReservationCost(monthDate, endDate, seasons, daySpecificRatesStatus)
                daysTotal = dayChunks.daysTotal;
                subTotal += dayChunks.daysTotal;
                subTotalWithoutDiscount += dayChunks.daysTotal
                console.log(JSON.stringify(dayChunks));
            }
        }

        let extras = await getSiteRigDiscountExtra(this.props.user, this.props.serverName)
        // if (this.props.viewItem.discount_id > 0)
        if (this.state.discount_id > 0) {
            selectedDiscount = extras[2].find(
                // (discount) => discount.id === this.props.viewItem.discount_id
                (discount) => discount.id === this.state.discount_id
            );
            if (selectedDiscount?.amount > 0) {
                discountTotal = selectedDiscount.amount
            } else if (selectedDiscount?.amount_daily > 0 || selectedDiscount?.amount_monthly > 0 || selectedDiscount?.amount_weekly > 0) {
                if (term[2] > 0 && selectedDiscount?.amount_monthly > 0) {
                    discountTotal += (term[2] * selectedDiscount.amount_monthly)
                }
                if (term[1] > 0 && selectedDiscount?.amount_weekly > 0) {
                    discountTotal += (term[1] * selectedDiscount.amount_weekly)
                }
                if (term[0] > 0 && selectedDiscount?.amount_daily > 0) {
                    discountTotal += (term[0] * selectedDiscount.amount_daily)
                }
            } else {
                if (monthsTotal > 0 && selectedDiscount?.disc_appl_month) {
                    discountTotal += (monthsTotal * selectedDiscount.discount_percent) / 100
                }
                if (weeksTotal > 0 && selectedDiscount?.disc_appl_week) {
                    discountTotal += (weeksTotal * selectedDiscount.discount_percent) / 100
                }
                if (daysTotal > 0 && selectedDiscount?.disc_appl_daily) {
                    discountTotal += (daysTotal * selectedDiscount.discount_percent) / 100
                }
                this.setState({
                    discountByPercent: true
                })
            }
            subTotalWithoutDiscount1 = subTotal;
            subTotal -= discountTotal
            subTotalWithoutDiscount = subTotal

        }
        // subTotal -= this.props.viewItem.onetime_discount
        subTotal -= this.state.oneTimeDiscount
        //update type 1 extras with newdates
        console.log("type ids: ", this.state.selectedExtrasTypeId)
        for (let index = 0; index < this.state.selectedExtrasTypeId.length; index++) {
            if (this.state.selectedExtrasTypeId[index] === 1) {
                // get the number of days by calling this.getDays() and passing old dates to function
                const daysCount = this.getDays();

                // divide the count with number of days
                const oldExtraCount = (this.state.selectedExtraCount[index] / daysCount)

                const extraRate = (this.state.selectedExtraAmount[index] / daysCount)
                // delete the extra with id
                let deleteResponse = await deleteAddedExtra(this.props.user, this.props.serverName, this.state.extraId[index])

                // add new extra with count
                const msPerDay = 24 * 60 * 60 * 1000;
                const startDate = new Date(this.state.editedStartDate);
                const endDate = new Date(this.state.editedEndDate);
                const totalDays = Math.floor((endDate - startDate) / msPerDay);
                const extraTotal = (oldExtraCount * totalDays * extraRate)
                const finalCount = oldExtraCount * totalDays
                const extraAmount = (oldExtraCount * totalDays * extraRate)
                let extraResponse = await addExtras(this.props.user, this.props.serverName, '1', this.props.viewItem.id, finalCount,
                    totalDays, extraAmount, format(new Date(), 'yyyy-MM-dd HH:mm:ss'))
            }
        }

        this.setState({
            reservationUpdated: true,
            days: term[0],
            weeks: term[1],
            months: term[2],
            season: this.props.seasonBooking ? '1' : '0',
            subTotal: subTotal,
            subTotalWithoutDiscount: subTotalWithoutDiscount,
            subTotalWithoutDiscount1: subTotalWithoutDiscount1,
            originalSubTotal: subTotal,
            seasonTotal: seasonTotal,
            monthsTotal: monthsTotal,
            weeksTotal: weeksTotal,
            daysTotal: daysTotal,
            sitetype_id: space.sitetype_id,
            daySpecificRatesStatus: daySpecificRatesStatus,
            monthChunks: monthChunks.chunks,
            weekChunks: weekChunks.chunks,
            dayChunks: dayChunks.chunks
        })
        this.calculateTaxAndTotal(subTotal + this.state.extrasTotal, term, 0);
        const createdAt = dayjs(this.props.viewItem.created_at);
        const now = dayjs();
        const isWithin2Days = Math.abs(now.diff(createdAt, 'day')) <= 2;
        if (!isWithin2Days && space.id != this.state.spaceId) {
            let response = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.props.viewItem.startdate, this.props.viewItem.enddate, 'manager', 'edited')
            console.log('added fee record for sitetype change');
        }
        if (Math.abs(dayjs(this.props.viewItem.enddate).diff(dayjs(this.state.editedEndDate), 'day')) > 7 || Math.abs(dayjs(this.props.viewItem.startdate).diff(dayjs(this.state.editedStartDate), 'day')) > 7) {
            let response = await addSystemFeeRecord(this.props.serverName, this.props.viewItem.id, this.state.editedStartDate, this.state.editedEndDate, 'manager', 'edited');
            console.log('added fee record for date change');
        }
        let changeResponse = await changeSpace(this.props.user, this.props.serverName, space.id, this.props.viewItem.id, this.state.editedStartDate, this.state.editedEndDate)
        this.setState({
            changeSpace: false,
            popupText: 'The date and space for reservation number ' + this.props.viewItem.id + ' has been updated successfully.',
            open: true
        })
    }

    addOneTimeDiscount = (event) => {
        const discount = event.target.value
        console.log(parseFloat(discount).toFixed(2))
        if (discount == "") {
            const subTotalWithoutDiscount = this.state.subTotalWithoutDiscount
            this.setState({
                oneTimeDiscount: 0,
                subTotal: subTotalWithoutDiscount
            })
            this.calculateTaxAndTotal(subTotalWithoutDiscount, this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate), this.state.extraSubTotal);
        } else if (discount >= 0) {
            // const numericValue = discount.replace(/[^0-9]/g, '');
            const numericValue = discount;
            let oneTimeDiscount = parseFloat(numericValue)
            const oldSubTotal = this.state.subTotal + (this.state.oneTimeDiscount || this.props.viewItem.onetime_discount)
            const subTotalWithoutDiscount = this.state.subTotalWithoutDiscount
            // let newSubtotal = parseFloat(oldSubTotal) - parseFloat(oneTimeDiscount)
            let newSubtotal = parseFloat(subTotalWithoutDiscount) - parseFloat(oneTimeDiscount)
            this.setState({
                oneTimeDiscount: oneTimeDiscount,
                subTotal: newSubtotal,
                reservationUpdated: true
            });
            this.calculateTaxAndTotal(newSubtotal, this.getDuration(this.props.viewItem.startdate, this.props.viewItem.enddate), this.state.extraSubTotal);
        }
    }

    newVariableChargeChange = (event) => {
        if (event.target.id === 'newVariableChargeAmount') {
            const amount = event.target.value
            // const alteredAmount = amount.replace(/[^0-9]/g, '');
            const alteredAmount = amount;
            this.setState({
                [event.target.id]: alteredAmount
            })
        } else {
            this.setState({
                [event.target.id]: event.target.type === "checkbox" ? event.target.checked : event.target.value
            })
        }
    }

    addNewVariableCharge = async () => {
        this.setState({
            reservationUpdated: true
        })
        let variableChargeResponse = await addVariableCharge(this.props.user, this.props.serverName, this.props.viewItem.id, this.state.newVariableChargeName, this.state.newVariableChargeAmount, new Date(), new Date(), this.state.taxable)
        const newCharge = {
            id: variableChargeResponse.insertId,
            reservation_id: this.props.viewItem.id,
            detail: this.state.newVariableChargeName,
            amount: Number(this.state.newVariableChargeAmount).toFixed(2),
            taxable: this.state.taxable ? 1 : 0,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
        };
        console.log(newCharge)
        this.setState({ variableCharges: [...this.state.variableCharges, newCharge] });
        let chargeAmount = this.state.taxable ? parseFloat(this.state.newVariableChargeAmount).toFixed(2) : 0
        console.log(chargeAmount)
        console.log(this.state.subTotal, chargeAmount);
        this.calculateTaxAndTotal(this.state.subTotal, this.getDuration(this.props.viewItem.checkIn, this.props.viewItem.checkOut), this.state.extraSubTotal);
    }

    goBack = () => {
        this.setState({
            pritOpen: false,
        });
    }

    render() {
        const { classes } = this.props;
        if (this.state.pritOpen) {
            return (
                <PrintReservation serverName={this.props.serverName} goBack={this.goBack} user={this.props.user} reservationId={this.props.viewItem.id} fname={this.state.customerDetails.first_name}
                    lname={this.state.customerDetails.last_name} email={this.state.customerDetails.email} phone={this.state.customerDetails.phone} address={this.state.customerDetails.address}
                    city={this.state.customerDetails.city} state={this.state.customerDetails.state} zip={this.state.customerDetails.mail_code} siteName={this.props.viewItem.sitename} siteType={this.props.viewItem.sitetype}
                    checkIn={this.props.viewItem.startdate} checkOut={this.props.viewItem.enddate} adults={this.props.viewItem.adults} childrens={this.props.viewItem.kids} subtotal={parseFloat(this.state.subTotal).toFixed(2)}
                    rigName={this.props.viewItem.rigname} rigLength={this.props.viewItem.rigLength} siteLength={this.props.viewItem.siteLength} boatType={this.props.viewItem.boatType} boatDraft={this.props.viewItem.boatDraft} boatLength={this.props.viewItem.boatLength} boatBeam={this.props.viewItem.boatBeam} freshWater={this.props.viewItem.freshWater} pumpOut={this.props.viewItem.pumpOut} e15a={this.props.viewItem.e15a} e30a={this.props.viewItem.e30a} e50a={this.props.viewItem.e50a} e100a={this.props.viewItem.e100a} slides={this.props.viewItem.slides}
                    totalAmount={parseFloat(this.state.totalAmount).toFixed(2)} balanceDue={(this.state.totalAmount - this.state.totalPaidAmount).toFixed(2)} serviceFees={this.state.convenienceCharge}
                    duration={this.getDays()} taxName={this.state.taxName} tax={this.state.tax} months={this.state.months} monthsTotal={parseFloat(this.state.monthsTotal).toFixed(2)} weeks={this.state.weeks}
                    weeksTotal={parseFloat(this.state.weeksTotal).toFixed(2)} days={this.state.days} daysTotal={parseFloat(this.state.daysTotal).toFixed(2)} monthly={this.state.monthly} weekly={this.state.weekly}
                    daily={this.state.daily} discount={parseFloat(this.state.discountTotal).toFixed(2)} oneTimeDiscount={parseFloat(this.state.oneTimeDiscount).toFixed(2)} selectedExtras={this.state.selectedExtras} 
                    selectedExtraCount={this.state.selectedExtraCount} selectedExtraAmount={this.state.selectedExtraAmount} variableCharges={this.state.variableCharges} payments={this.state.payments} blended={this.state.blended}
                    total={this.props.viewItem.total} tax_amount={this.props.viewItem.tax_amount} amount_paid={this.props.viewItem.amount_paid} archived={this.props.viewItem?.archived} seasonal={this.props.viewItem.seasonal}
                />
            )
        } else {
            return (
                <>
                    <Dialog open={this.state.open} onClose={() => this.setState({ open: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogContent>
                            {this.state.popupText}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.popupClose()} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.open1} onClose={() => this.setState({ open: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogContent>
                            {this.state.popupText1}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.open2} onClose={() => this.setState({ open2: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogTitle>Processing Your Payment</DialogTitle>
                        <DialogContent>
                            Please do not close this window or click back while we process your payment.
                        </DialogContent>
                    </Dialog>

                    <Dialog open={this.state.open3} onClose={() => this.setState({ open3: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogTitle>{this.state.Popup3DialogTitle}</DialogTitle>
                        <DialogContent>
                            {this.state.popup3Text}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.popup3Close()} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.extraPopup} onClose={() => this.setState({ extraPopup: false })} classes={{ paper: classes.dialogPaper }}>
                        <DialogTitle>
                            Extras
                        </DialogTitle>
                        <DialogContent>
                            {this.state.extraPopupTitle}
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.setState({ extraPopup: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.changeSpace} onClose={() => this.setState({ changeSpace: false })} classes={{ paper: classes.dialogPaper }}
                        maxWidth={false}>
                        <DialogTitle style={{ fontSize: '2rem' }}>{this.state.chnageSpaceTitle}</DialogTitle>
                        <DialogContent>
                            {this.state.showNewSpaces
                                ?
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Space Name</TableCell>
                                            <TableCell>Site Type</TableCell>
                                            <TableCell>Electric</TableCell>
                                            <TableCell>Water</TableCell>
                                            <TableCell>Sewer</TableCell>
                                            <TableCell>Daily</TableCell>
                                            <TableCell>Weekly</TableCell>
                                            <TableCell>Monthly</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.spaceData
                                            // .filter(space => space.space_name !== this.props.viewItem.sitename)
                                            .map((space, index) => (
                                                <TableRow key={index} className="rows">
                                                    <TableCell>{space.space_name}</TableCell>
                                                    <TableCell>{space.sitetype_name}</TableCell>
                                                    <TableCell>
                                                        {space.power_50a
                                                            ? 'Electric (50A)'
                                                            : space.power_30a
                                                                ? 'Electric (30A)'
                                                                : space.power_15a
                                                                    ? 'Electric (15A)'
                                                                    : 'No Electric'
                                                        }
                                                    </TableCell>
                                                    <TableCell>{space.water ? 'Water' : 'No Water'}</TableCell>
                                                    <TableCell>{space.sewer ? 'Sewer' : 'No Sewer'}</TableCell>
                                                    <TableCell>${parseFloat(space.daily_rate).toFixed(2)}</TableCell>
                                                    <TableCell>${parseFloat(space.weekly_rate).toFixed(2)}</TableCell>
                                                    <TableCell>${parseFloat(space.monthly_rate).toFixed(2)}</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            className="selectButton"
                                                            onClick={() => this.newSpaceSelected(space)}
                                                            style={{
                                                                // backgroundColor: '#2dcd7a',
                                                                backgroundColor: space.space_name === this.props.viewItem.sitename ? '#d4d4d4' : '#2dcd7a',
                                                                color: '#000000',
                                                                padding: '2% 10% 2% 10%',
                                                                borderRadius: '10px',
                                                                textTransform: 'capitalize',
                                                            }}
                                                        >
                                                            {space.space_name === this.props.viewItem.sitename ? 'Current' : 'Select'}
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                                :
                                <ThemeProvider theme={theme}>
                                    <div style={{ display: 'flex', gap: '5%' }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                id="editedStartDate"
                                                label="Check In*"
                                                value={dayjs(this.state.editedStartDate)}
                                                onChange={(date) => {
                                                    this.setState({ editedStartDate: dayjs(date).format('YYYY-MM-DD') });
                                                }}
                                            />
                                        </LocalizationProvider>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                id="editedEndDate"
                                                label="Check Out*"
                                                value={dayjs(this.state.editedEndDate)}
                                                minDate={dayjs(this.state.editedStartDate).add(1, "day")}
                                                onChange={(date) => {
                                                    this.setState({ editedEndDate: dayjs(date).format('YYYY-MM-DD') });
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </ThemeProvider>
                            }
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={() => this.setState({ changeSpace: false, showNewSpaces: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '1%', margin: '3% 2% 0 2%', borderRadius: '10px', textTransform: "capitalize" }}>
                                Close
                            </Button>
                            {this.state.showNewSpaces
                                ? null
                                :
                                <Button onClick={this.changeSpace} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '1%', margin: '3% 2% 0 2%', borderRadius: '10px', textTransform: "capitalize" }}>
                                    Select Space
                                </Button>
                            }
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.saveCardOnFileDialogue} onClose={() => this.setState({ saveCardOnFileDialogue: false })}>
                        <DialogTitle>Card Storage Compliance Notice</DialogTitle>
                        <DialogContent>
                            <Typography style={{ marginBottom: '2%' }}>By enabling the "Save Card on File" feature, you confirm that:</Typography>
                            <Typography style={{ marginBottom: '2%', marginLeft: '5%' }}> • You will obtain and document guest consent before storing their card information.</Typography>
                            <Typography style={{ marginBottom: '2%' }}><strong>Legal Requirement:</strong> : Storing payment cards without explicit customer consent violates payment card regulations and may result in financial penalties, chargebacks, and loss of payment processing privileges.</Typography>

                            <FormControlLabel
                                label={`I understand these requirements and will ensure proper consent is obtained before storing any payment card information.`}
                                control={
                                    <GreenCheckbox
                                        id="complianceAgreed"
                                        checked={this.state.complianceAgreed}
                                        onChange={(e) => this.setState({ complianceAgreed: e.target.checked, saveCardOnFileDialogue: false })}
                                    />
                                }
                            />
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={() => this.setState({ saveCardOnFileDialogue: false, saveCard: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={this.state.cancelPopup} onClose={() => { this.setState({ cancelPopup: false }) }} classes={{ paper: classes.dialogPaper }}>
                        <DialogTitle>Confirm Cancellation</DialogTitle>
                        <DialogContent>
                            <ThemeProvider theme={theme}>
                                Proceed with cancellation for Reservation number: {this.props.viewItem.id} .
                                <div style={{ display: 'flex', marginTop: '5%' }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Reason for Cancellation
                                    </Typography>
                                    <Select
                                        value={this.state.cancellationReason}
                                        onChange={(e) => this.setState({ cancellationReason: e.target.value })}
                                        displayEmpty
                                        fullWidth
                                    >
                                        <MenuItem value="">Select a reason</MenuItem>
                                        <MenuItem value="change_of_plans">Change of plans, no longer need the reservation</MenuItem>
                                        <MenuItem value="weather">Severe weather or unsafe conditions</MenuItem>
                                        <MenuItem value="illness">Illness or medical emergency</MenuItem>
                                        <MenuItem value="family_emergency">Family emergency requiring travel changes</MenuItem>
                                        <MenuItem value="work_conflict">Work schedule conflicts</MenuItem>
                                        <MenuItem value="financial_constraints">Unexpected financial constraints</MenuItem>
                                        <MenuItem value="vehicle_issues">RV, boat, or vehicle issues</MenuItem>
                                        <MenuItem value="incorrect_booking">Incorrect date, site type, or location booked</MenuItem>
                                        <MenuItem value="group_canceled">Group or travel companions canceled</MenuItem>
                                        <MenuItem value="event_canceled">Event cancellation or rescheduling</MenuItem>
                                        <MenuItem value="travel_restrictions">Illness, exposure, or travel restrictions</MenuItem>
                                        <MenuItem value="safety_concerns">Safety concerns about the site or area</MenuItem>
                                        <MenuItem value="better_accommodation">Found a better-suited accommodation</MenuItem>
                                        <MenuItem value="not_meet_expectations">Site does not meet expectations or needs</MenuItem>
                                        <MenuItem value="road_closures">Road closures or government travel restrictions</MenuItem>
                                        <MenuItem value="overbooking">Reservation canceled due to overbooking</MenuItem>
                                        <MenuItem value="maintenance">Site closed for maintenance or repairs</MenuItem>
                                        <MenuItem value="extreme_weather">Extreme weather affecting site access</MenuItem>
                                        <MenuItem value="health_safety">Health or safety issues at the property</MenuItem>
                                        <MenuItem value="policy_conflict">Policy conflict</MenuItem>
                                        <MenuItem value="payment_issues">Payment issues or failed transaction</MenuItem>
                                        <MenuItem value="prior_misconduct">Prior misconduct or policy violations</MenuItem>
                                        <MenuItem value="staffing_shortages">Staffing shortages affecting operations</MenuItem>
                                        <MenuItem value="facility_issues">Power, water, or facility issues</MenuItem>
                                        <MenuItem value="legal_changes">Legal or regulatory changes</MenuItem>
                                        <MenuItem value="no_show">No Show</MenuItem>
                                    </Select>
                                </div>
                                <div style={{ display: 'flex', marginTop: '5%', alignItems: 'center' }}>

                                    <Typography style={{ marginRight: '5%' }}>Cancellation Charge</Typography>
                                    <TextField id="cancellationCharge" label="Cancellation Charge" type="text"
                                        onChange={(e) => {
                                            if (/^(?!-)(\d{0,3}(\.\d{0,2})?)?$/.test(e.target.value)) {
                                                this.setState({ cancellationCharge: e.target.value });
                                            }
                                        }}
                                        value={this.state.cancellationCharge} inputProps={{ inputMode: 'numeric' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', marginTop: '5%', alignItems: 'center' }}>
                                    <Typography>
                                        After hitting confirm, you will be taken to the transaction page where you can initiate a partial refund of ${this.state.cancellationCharge}.
                                        An email notification will be automatically sent to the Guest if there is an email on file.
                                    </Typography>
                                </div>
                            </ThemeProvider>
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={() => { this.setState({ cancelPopup: false }) }} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Cancel
                            </Button>
                            <Button onClick={this.cancel} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {this.state.waitForCalculations
                        ?
                        <CircularProgress className={classes.circularProgress} />
                        :
                        <>
                            <Grid className='view' >
                                <Box className='infoBox' style={{ marginRight: '1.5%', marginBottom: '-3%' }}>
                                    <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                                    <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                                </Box>

                                <Box className='box' style={{ width: '85%' }}>
                                    <Typography className='reservationstypography'>Reservation Number: {this.props.viewItem.id}</Typography>
                                </Box>

                                <Box className='actionButtons'>
                                    {this.props.viewItem.unconfirmed_remote === 1
                                        ?
                                        <>
                                            {!this.props.viewItem?.archived && <Button
                                                className='button'
                                                onClick={() => { this.setState({ cancelPopup: true }) }}
                                            >
                                                Cancel Reservation
                                            </Button>}
                                            {!this.props.viewItem?.archived && <Button
                                                className='button'
                                                onClick={this.confirm}
                                            >
                                                Confirm Reservation
                                            </Button>}
                                            <Button
                                                className='button'
                                                onClick={() => { this.setState({ waitForCalculations: true }); this.props.goBack() }}
                                            >
                                                Back
                                            </Button>
                                        </>
                                        :
                                        <>
                                            {this.props.viewItem.checked_in === 1
                                                ? !this.props.viewItem?.archived && <Button
                                                    className='button'
                                                    onClick={this.checkOut}
                                                >
                                                    Check Out
                                                </Button>
                                                : !this.props.viewItem?.archived && <Button
                                                    className='button'
                                                    onClick={this.checkIn}
                                                >
                                                    Check In
                                                </Button>
                                            }
                                            {!this.props.viewItem?.archived && <Button
                                                className='button'
                                                onClick={() => { this.setState({ cancelPopup: true }) }}
                                            >
                                                Cancel Reservation
                                            </Button>}
                                            {!this.props.viewItem?.archived && <Button
                                                className='button'
                                                onClick={this.sendReservationUpdate}
                                            >
                                                Send Update Email
                                            </Button>}
                                            {!this.props.viewItem?.archived && <Button
                                                className='button'
                                                onClick={() => { this.setState({ changeSpace: true }) }}
                                            >
                                                Change Site/Dates
                                            </Button>}
                                            <Button
                                                className='button'
                                                onClick={() => { this.setState({ waitForCalculations: true }); this.props.goBack() }}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                className='button'
                                                onClick={() => { this.setState({ pritOpen: true }) }}
                                            >
                                                Print
                                            </Button>
                                        </>
                                    }
                                </Box>

                                <Box className='main' style={{ marginRight: '2%' }}>
                                    <Box className='leftRow'>
                                        <Box className='userDetails'>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography className='typo'>Guest Details</Typography>
                                                {this.state.disabledTextFields
                                                    ? <Button style={{ margin: '4% 4% 0 0', height: '5%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                        onClick={() => { this.setState({ disabledTextFields: false }) }} disabled={this.props.viewItem?.archived}> Edit Details</Button>
                                                    :
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '30%', alignItems: 'center', margin: '1% 3% 0 0' }}>
                                                        <Button style={{ margin: '4% 4% 0 0', height: '70%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    disabledTextFields: true,
                                                                    fname: this.state.customerDetails.first_name,
                                                                    lname: this.state.customerDetails.last_name,
                                                                    emailId: this.state.customerDetails.email,
                                                                    phoneNumber: this.state.customerDetails.phone,
                                                                    address: this.state.customerDetails.address,
                                                                    city: this.state.customerDetails.city,
                                                                    state: this.state.customerDetails.state,
                                                                    zip: this.state.customerDetails.mail_code
                                                                })
                                                            }}> Cancel</Button>
                                                        <Button style={{ margin: '4% 4% 0 0', height: '70%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                            onClick={() => { this.updateCustomerDetails() }}> Save Details</Button>
                                                    </div>
                                                }
                                            </div>
                                            <hr className='horizontalLine' />
                                            <ThemeProvider theme={theme}>
                                                <div className='form-row'>
                                                    <TextField id="fname" required disabled={this.state.disabledTextFields} label="First Name" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled' : 'field'}`}
                                                        value={this.state.fname}
                                                        onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                    <TextField id="lname" required disabled={this.state.disabledTextFields} label="Last Name" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled' : 'field'}`}
                                                        value={this.state.lname} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                </div>

                                                <div className='form-row'>
                                                    <TextField id="emailId" required disabled={this.state.disabledTextFields} label="Email Id" type="email"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled' : 'field'}`}
                                                        value={this.state.emailId} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                    <TextField id="phoneNumber" required disabled={this.state.disabledTextFields} label="Phone Number" type={this.state.disabledTextFields ? 'text' : 'number'}
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled' : 'field'}`}
                                                        value={this.state.phoneNumber} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                </div>

                                                <div className='form-row-2'>
                                                    <TextField id="address" required disabled={this.state.disabledTextFields} label="Address" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled full-width' : 'full-width'}`}
                                                        value={this.state.address} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                </div>
                                                <div className='form-row-3'>
                                                    <TextField id="city" required disabled={this.state.disabledTextFields} label="City" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled left' : 'left'}`}
                                                        value={this.state.city} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                    <TextField id="state" required disabled={this.state.disabledTextFields} label="State" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled middle' : 'middle'}`}
                                                        value={this.state.state} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                    <TextField id="zip" required disabled={this.state.disabledTextFields} label="Postal Code" type="text"
                                                        className={`field ${this.state.disabledTextFields ? 'custom-disabled right' : 'right'}`}
                                                        value={this.state.zip} onChange={this.userDetailsChange} InputLabelProps={{ shrink: true }} />
                                                </div>
                                            </ThemeProvider>
                                        </Box>

                                        {!this.props.viewItem?.archived && this.state.useVariable
                                            ?
                                            <Box className='variableCharge'>
                                                <Typography className='typo'>Variable Charges</Typography>
                                                <hr className='horizontalLine' />
                                                <ThemeProvider theme={theme}>
                                                    <Box style={{ display: 'flex', justifyContent: 'space-between', margin: '0 3% 2% 3%' }}>
                                                        <TextField style={{ width: '30%', marginRight: '-20%' }} onChange={this.newVariableChargeChange}
                                                            id="newVariableChargeName" type="text" label="Item"
                                                            value={this.state.newVariableChargeName}
                                                        />
                                                        <TextField style={{ width: '20%', marginRight: '-20%' }} onChange={this.newVariableChargeChange}
                                                            id="newVariableChargeAmount" type="number" label="Amount"
                                                            // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                            inputProps={{ step: "any", min: "0" }}
                                                            value={this.state.newVariableChargeAmount}
                                                        />
                                                        <FormControlLabel
                                                            label={"Taxable?"}
                                                            style={{ width: '20%', marginRight: '-22%' }}
                                                            control={
                                                                <Checkbox
                                                                    id="taxable"
                                                                    checked={this.state.taxable}
                                                                    onChange={this.newVariableChargeChange}
                                                                />
                                                            }
                                                        />
                                                        <Button onClick={() => this.addNewVariableCharge()}
                                                            style={{
                                                                width: '20%', color: '#000000', textTransform: 'capitalize', marginRight: '1%',
                                                                backgroundColor: !this.state.newVariableChargeName || this.state.newVariableChargeAmount <= 0 ? '#d4d4d4' : '#2dcd7a'
                                                            }}
                                                            disabled={!this.state.newVariableChargeName || this.state.newVariableChargeAmount <= 0}
                                                        >
                                                            Add
                                                        </Button>
                                                    </Box>
                                                </ThemeProvider>
                                            </Box>
                                            : null
                                        }
                                        {this.state.variableCharges.length > 0
                                            ?
                                            <Box className='addOns'>
                                                <Typography className='typo'>Variable Charges </Typography>
                                                <hr className='horizontalLine' />
                                                <ThemeProvider theme={theme}>
                                                    <Box className='addOnsForm'>
                                                        <Typography>Item</Typography>
                                                        <Typography>Amount</Typography>
                                                        <Typography>Taxable</Typography>
                                                    </Box>
                                                    {this.state.variableCharges.map((extra, index) => (
                                                        <Box key={index} className='addOnsForm'>
                                                            <Typography>{this.state.variableCharges[index].detail}</Typography>
                                                            <Typography>{this.state.variableCharges[index].amount}</Typography>
                                                            <Checkbox disabled={true} checked={this.state.variableCharges[index].taxable} />
                                                            {!this.props.viewItem?.archived && <Button
                                                                style={{ backgroundColor: '#FDECEB', color: '#DB3737', borderRadius: '5px', width: '80%', marginTop: '-2%' }}
                                                                onClick={() => this.deleteVariableCharge(index)}
                                                            >
                                                                Delete
                                                            </Button>}
                                                        </Box>
                                                    ))}
                                                </ThemeProvider>
                                            </Box>
                                            : null
                                        }

                                        {this.state.selectedExtras.length > 0
                                            ?
                                            <Box className='addOns'>
                                                <Typography className='typo'>Extras </Typography>
                                                <hr className='horizontalLine' />
                                                <ThemeProvider theme={theme}>
                                                    <Box className='addOnsForm'>
                                                        <Typography>Extra Name</Typography>
                                                        <Typography>Count</Typography>
                                                        <Typography>Total</Typography>
                                                    </Box>
                                                    {this.state.selectedExtras.map((extra, index) => (
                                                        <Box key={index} className='addOnsForm'>
                                                            <Typography>{this.state.selectedExtras[index]}</Typography>
                                                            <Typography>{this.state.selectedExtraCount[index]}</Typography>
                                                            <Typography>${parseFloat(this.state.selectedExtraAmount[index]).toFixed(2)}</Typography>
                                                            {!this.props.viewItem?.archived && <Button
                                                                style={{ backgroundColor: '#FDECEB', color: '#DB3737', borderRadius: '5px', width: '80%', marginTop: '-2%' }}
                                                                onClick={() => this.deleteExtra(index)}
                                                            >
                                                                Delete
                                                            </Button>}
                                                        </Box>
                                                    ))}
                                                </ThemeProvider>
                                            </Box>
                                            : null
                                        }

                                        {!this.props.viewItem?.archived && <Box className='addOns'>
                                            <Typography className='typo'>Add-Ons</Typography>
                                            <hr className='horizontalLine' />
                                            <Typography style={{ marginLeft: '-30%', marginBottom: '4%', fontSize: '1.1rem' }}>Last recorded meter reading for this space: {this.state.lastMeterReading}</Typography>
                                            <ThemeProvider theme={theme}>
                                                {this.state.extras
                                                    .map((extra, index) => (
                                                        <Box key={index} className='addOnsForm'>
                                                            {extra.extra_type === 4 || extra.extra_type === 0
                                                                ?
                                                                <>
                                                                    <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                    <Button
                                                                        className='ab'
                                                                        onClick={() => this.addExtra(extra)}
                                                                    >
                                                                        Add
                                                                    </Button>
                                                                </>
                                                                : null
                                                            }
                                                            {extra.extra_type === 2
                                                                ?
                                                                <>
                                                                    <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                    <TextField
                                                                        required
                                                                        label="Start"
                                                                        id="start"
                                                                        type="number"
                                                                        className='textfields'
                                                                        value={this.state.start[index] || ''}
                                                                        onChange={(event) => this.handleStartEnd(event, index)}
                                                                    />
                                                                    <TextField
                                                                        required
                                                                        label="End"
                                                                        id="end"
                                                                        type="number"
                                                                        className='textfields'
                                                                        value={this.state.end[index] || ''}
                                                                        onChange={(event) => this.handleStartEnd(event, index)}
                                                                    />
                                                                    <Button
                                                                        className='ab'
                                                                        onClick={() => this.addExtra(extra, 0, index)}
                                                                        disabled={!this.state.type2Add}
                                                                    >
                                                                        Add
                                                                    </Button>
                                                                </>
                                                                : null
                                                            }
                                                            {extra.extra_type === 1 || extra.extra_type === 3
                                                                ?
                                                                <>
                                                                    <Typography className='bookingLabel'>{extra.name}</Typography>
                                                                    <TextField
                                                                        required
                                                                        label="Count"
                                                                        type="number"
                                                                        className='textfields'
                                                                        value={this.state.counts[index] || ''}
                                                                        onChange={(event) => this.handleCountChange(index, event)}
                                                                    />
                                                                    <Button
                                                                        className='ab'
                                                                        onClick={() => this.addExtra(extra, this.state.counts[index])}
                                                                        disabled={!(this.state.counts[index] && this.state.counts[index] > 0)}
                                                                    >
                                                                        Add
                                                                    </Button>
                                                                </>
                                                                : null
                                                            }
                                                        </Box>
                                                    ))}
                                            </ThemeProvider>
                                        </Box>}

                                        {!this.props.viewItem?.archived && <Box className='payment'>
                                            <Typography className='typo'>Payment Information</Typography>
                                            <hr className='horizontalLine' />
                                            <ThemeProvider theme={theme}>
                                                <Box className='paymentOptionWrapper' style={{gap:'5px'}}>

                                                    {this.state.paymentIntegration.name === 'None' || this.state.paymentIntegration.name === 'CampPay_r' || this.state.paymentIntegration.name === 'CardConnect_r'
                                                        ?
                                                        <>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "cash" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("cash") }}>
                                                                Cash
                                                            </Box>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "check" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("check") }}>
                                                                Check / Money Order
                                                            </Box>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "others" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("others") }}>
                                                                Offline Payment method
                                                            </Box>
                                                        </>
                                                        :
                                                        <>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "fullPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("fullPayment") }}>
                                                                Card (Full)
                                                            </Box>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "partialPayment" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("partialPayment") }}>
                                                                Card (Partial)
                                                            </Box>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "cash" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("cash") }}>
                                                                Cash
                                                            </Box>
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "check" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("check") }}>
                                                                Check / Money Order
                                                            </Box>
                                                            {this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o'
                                                                || this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                ?
                                                                <Box className={`paymentOption ${this.state.selectedPaymentValue === "ccPOS" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("ccPOS") }}>
                                                                    Terminal
                                                                </Box>
                                                                : null
                                                            }
                                                            <Box className={`paymentOption ${this.state.selectedPaymentValue === "others" ? "activePaymentOption" : ""}`} onClick={() => { this.handlePaymentSelect("others") }}>
                                                                Offline Payment method
                                                            </Box>
                                                        </>
                                                    }
                                                </Box>   
                                                {(this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') && (!this.state.paymentIntegration.name.includes('Stripe'))
                                                    ? (
                                                        <>
                                                            {this.state.selectedPaymentValue === 'fullPayment'
                                                                ? (
                                                                    <>
                                                                        <div className='rows'>
                                                                            <Typography className='headings'>Amount to be paid</Typography>
                                                                            <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                className='resRight' value={parseFloat(this.state.totalPayableAmt).toFixed(2)} disabled={true} variant='standard' />
                                                                        </div>
                                                                        {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                            ?
                                                                            <>
                                                                                {this.state.last4 != null
                                                                                    ?
                                                                                    <div className='rows'>
                                                                                        <FormControlLabel
                                                                                            label={`Pay with card ending in: ${this.state.last4}`}
                                                                                            control={
                                                                                                <GreenCheckbox
                                                                                                    id="payWithSavedCard"
                                                                                                    checked={this.state.payWithSavedCard}
                                                                                                    onChange={(e) => this.setState({ payWithSavedCard: e.target.checked })}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    : null
                                                                                }
                                                                            </>
                                                                            : null
                                                                        }
                                                                    </>
                                                                )
                                                                : (
                                                                    <>
                                                                        {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                            ?
                                                                            <>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Amount to be paid</Typography>
                                                                                    <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                        className='resRight' value={parseFloat(this.state.partialBase).toFixed(2)} onChange={this.amountChange} />
                                                                                </div>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Service fees</Typography>
                                                                                    <TextField id="paymentAmt" type="number"
                                                                                        className='resRight' value={parseFloat(this.state.convenienceCharge).toFixed(2)} disabled={true} variant='standard' />
                                                                                </div>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Total</Typography>
                                                                                    <TextField id="paymentAmt" type="number"
                                                                                        className='resRight' value={parseFloat(this.state.partialTotal).toFixed(2)} disabled={true} variant='standard' />
                                                                                </div>
                                                                                {this.state.last4 != null
                                                                                    ?
                                                                                    <div className='rows'>
                                                                                        <FormControlLabel
                                                                                            label={`Pay with card ending in: ${this.state.last4}`}
                                                                                            control={
                                                                                                <GreenCheckbox
                                                                                                    id="payWithSavedCard"
                                                                                                    checked={this.state.payWithSavedCard}
                                                                                                    onChange={(e) => this.setState({ payWithSavedCard: e.target.checked })}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    : null
                                                                                }
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Amount to be paid</Typography>
                                                                                    <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                        className='resRight' value={this.state.partialTotal} onChange={this.amountChange} />
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                            {this.state.payWithSavedCard
                                                                ? null :
                                                                <>
                                                                    <Typography className='typo'>Card Details</Typography>
                                                                    <hr className='horizontalLine' />
                                                                    <Box className='cardDetailsBox' style={{ marginBottom: "50px" }}>
                                                                        <Box style={{ display: 'flex', width: "85%" }}>
                                                                            <div className='row'>
                                                                                <Typography className='typo'>Card Number</Typography>
                                                                                <TextField
                                                                                    InputProps={{
                                                                                        startAdornment: <CreditCardIcon />
                                                                                    }}
                                                                                    id="cardNumber" required label="Card Number" type="number"
                                                                                    className='resRight' value={this.state.cardNumber} onChange={this.handlePaymentDetailsChange} />
                                                                            </div>

                                                                            <div className='row'>
                                                                                <Typography className='typo'>Card Owner</Typography>
                                                                                <TextField InputProps={{
                                                                                    startAdornment: <PersonIcon />
                                                                                }} id="cardOwner" required label="Card Owner" type="text"
                                                                                    className='resRight' value={this.state.cardOwner} onChange={this.handlePaymentDetailsChange} />
                                                                            </div>
                                                                        </Box>
                                                                        <Box style={{ display: 'flex', marginTop: "30px" }}>
                                                                            <div className='expiryInputRow'>
                                                                                <Typography className='typo'>Expiration Date</Typography>
                                                                                <Box style={{ display: 'flex' }}>
                                                                                    <TextField style={{ width: "150px" }} InputProps={{
                                                                                        startAdornment: <TodayIcon />
                                                                                    }} id="expiryMonth" required label="MM" type="number" placeholder="MM"
                                                                                        className='expiryInput' value={this.state.expiryMonth} onChange={this.handlePaymentDetailsChange} />
                                                                                    <TextField style={{ width: "150px" }} InputProps={{
                                                                                        startAdornment: <DateRangeIcon />
                                                                                    }} id="expiryYear" required label="YY" type="number" placeholder="YY"
                                                                                        className='expiryInputYY' value={this.state.expiryYear} onChange={this.handlePaymentDetailsChange} />
                                                                                </Box>
                                                                            </div>
                                                                            <div className='row' style={{ marginLeft: "50px" }}>
                                                                                <Typography className='typo'>CVV</Typography>
                                                                                <TextField style={{ width: "150px" }} InputProps={{
                                                                                    startAdornment: <KeyIcon />
                                                                                }} id="cvv" required label="CVV" type="number"
                                                                                    className='cvvInput' value={this.state.cvv} onChange={this.handlePaymentDetailsChange} />
                                                                            </div>
                                                                        </Box>
                                                                    </Box>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', justifyContent: 'center' }}>
                                                                        {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                                            ? <>
                                                                                <ThemeProvider theme={theme} classes={{ paper: classes.dialogPaper }}>
                                                                                    <FormControlLabel
                                                                                        style={{ marginTop: '-2%' }}
                                                                                        label={"Save this card for future"}
                                                                                        control={
                                                                                            <GreenCheckbox
                                                                                                id="saveCard"
                                                                                                checked={this.state.saveCard}
                                                                                                onChange={(event) => this.setState({ saveCard: event.target.checked, saveCardOnFileDialogue: true })}
                                                                                            />
                                                                                        }
                                                                                    />
                                                                                </ThemeProvider>
                                                                            </>
                                                                            : null
                                                                        }
                                                                    </div>
                                                                </>
                                                            }
                                                            <Button
                                                                className='ab'
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </>
                                                    )
                                                    : null
                                                }
                                                {(this.state.selectedPaymentValue === 'fullPayment' || this.state.selectedPaymentValue === 'partialPayment') && (this.state.paymentIntegration.name === 'Stripe_o' || this.state.paymentIntegration.name === 'Stripe')
                                                    ? (
                                                        <>
                                                            {this.state.selectedPaymentValue === 'fullPayment'
                                                                ? (
                                                                    <>
                                                                        <div className='rows'>
                                                                            <Typography className='headings'>Amount to be paid</Typography>
                                                                            <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                className='resRight' value={parseFloat(this.state.totalPayableAmt).toFixed(2)} disabled={true} variant='standard' />
                                                                        </div>
                                                                        {this.state.paymentIntegration.name === 'Stripe' || this.state.paymentIntegration.name === 'Stripe_o'
                                                                            ?
                                                                            <div style={{width:'90%'}}>
                                                                                <StripePayment
                                                                                amount={this.state.totalPayableAmt}
                                                                                connectedAccountId={this.state.paymentIntegration.stripe_account_id}
                                                                                onPaymentSuccess={this.handleStripeSuccess}
                                                                                handleStripeFail={this.handleStripeFail}
                                                                                billingDetails={{
                                                                                    name: `${this.state.fname} ${this.state.lname}`,
                                                                                    email: this.state.emailId,
                                                                                    phone: this.state.phoneNumber,
                                                                                    address: {
                                                                                        line1: this.state.address,
                                                                                        city: this.state.city,
                                                                                        state: this.state.state,
                                                                                        postal_code: this.state.zip,
                                                                                        country: 'US',
                                                                                    },
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            : null
                                                                        }
                                                                    </>
                                                                )
                                                                : (
                                                                    <>
                                                                        {this.state.paymentIntegration.name === 'Stripe' || this.state.paymentIntegration.name === 'Stripe_o'
                                                                            ?
                                                                            <>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Amount to be paid</Typography>
                                                                                    <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                        className='resRight' value={this.state.partialTotal} onChange={this.amountChange} />
                                                                                </div>
                                                                                <StripePayment
                                                                                amount={this.state.partialTotal}
                                                                                connectedAccountId={this.state.paymentIntegration.stripe_account_id}
                                                                                onPaymentSuccess={this.handleStripeSuccess}
                                                                                handleStripeFail={this.handleStripeFail}
                                                                                billingDetails={{
                                                                                    name: `${this.state.fname} ${this.state.lname}`,
                                                                                    email: this.state.emailId,
                                                                                    phone: this.state.phoneNumber,
                                                                                    address: {
                                                                                        line1: this.state.address,
                                                                                        city: this.state.city,
                                                                                        state: this.state.state,
                                                                                        postal_code: this.state.zip,
                                                                                        country: 'US',
                                                                                    },
                                                                                    }}
                                                                                />
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <div className='rows'>
                                                                                    <Typography className='headings'>Amount to be paid</Typography>
                                                                                    <TextField id="paymentAmt" required label="Amount" type="number"
                                                                                        className='resRight' value={this.state.partialTotal} onChange={this.amountChange} />
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                    : null
                                                }
                                                {this.state.selectedPaymentValue === 'cash'
                                                    ?
                                                    <>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Cash Amount</Typography>
                                                            <TextField id="cashAmount" required label="Amount" type="number"
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Date</Typography>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    id='cashDate'
                                                                    label='Cash Date*'
                                                                    className='date'
                                                                    onChange={(date) => {
                                                                        this.setState({ cashDate: date }, () => {
                                                                            this.userDetailsValidation();
                                                                        })
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                        <div className='rows'>
                                                            <Button
                                                                className='ab'
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </div>
                                                    </>
                                                    : null
                                                }
                                                {this.state.selectedPaymentValue === 'check'
                                                    ?
                                                    <>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Check Amount</Typography>
                                                            <TextField id="checkAmount" required label="Amount" type="number"
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Check Number</Typography>
                                                            <TextField id="checkNumber" required label="Number" type="number"
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Memo</Typography>
                                                            <TextField id="memo" required label="Memo" type="text"
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Date</Typography>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    id='checkDate'
                                                                    label='Check Date*'
                                                                    className='date'
                                                                    onChange={(date) => {
                                                                        this.setState({ checkDate: date }, () => {
                                                                            this.userDetailsValidation();
                                                                        })
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                        <div className='rows'>
                                                            <Button
                                                                className='ab'
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </div>
                                                    </>
                                                    : null
                                                }
                                                {this.state.selectedPaymentValue === 'ccPOS'
                                                    ?
                                                    <>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Amount to be paid</Typography>
                                                            <TextField id="ccPOSAmount" required label="Amount" type="number"
                                                                className='resRight' value={this.state.ccPOSAmount} onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Button
                                                                className='ab'
                                                                onClick={this.pay}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </div>
                                                    </>
                                                    : null
                                                }
                                                {this.state.selectedPaymentValue === 'others'
                                                    ?
                                                    <>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Amount</Typography>
                                                            <TextField id="offlineAmount" required label="Amount" type="number" value={this.state.offlineAmount}
                                                                className='resRight' onChange={this.amountChange} inputProps={{min: 0}} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Method</Typography>
                                                            <Select
                                                            style={{ width: "75%", textAlign: 'left', boxShadow: 'none' }}
                                                            id="offlineMethod"
                                                            value={this.state.offlineMethod || ''}
                                                            label="Select Method"
                                                            disabled={this.props.viewItem?.archived}
                                                            required
                                                            onChange={this.offlineMethodChange}
                                                            >
                                                            {methods.map((method, index) => (
                                                                <MenuItem key={index} value={method}>
                                                                    {method}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Reference Number</Typography>
                                                            <TextField id="offlineMemo" label="Memo" type="text" value={this.state.offlineMemo}
                                                                className='resRight' onChange={this.amountChange} />
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Last 4 of credit card</Typography>
                                                            <TextField id="offlineLast4" label="Last 4" type="number" value={this.state.offlineLast4}
                                                                className='resRight' onChange={this.amountChange} inputProps={{min: 0,max: 9999,maxLength: 4}}/>
                                                        </div>
                                                        <div className='rows'>
                                                            <Typography className='headings'>Date</Typography>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    id='offlinePaymentDate'
                                                                    label='Date*'
                                                                    className='date'
                                                                    onChange={(date) => {
                                                                        this.setState({ offlinePaymentDate: date }, () => {
                                                                            this.userDetailsValidation();
                                                                        })
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                        <div className='rows'>
                                                            <Button
                                                                className='ab'
                                                                onClick={this.pay}
                                                                disabled={!this.state.userDetailsFormValid}
                                                            >
                                                                Pay
                                                            </Button>
                                                        </div>
                                                    </>
                                                    : null
                                                }
                                            </ThemeProvider>
                                        </Box>}
                                    </Box>

                                    <Box className='rightRow'>
                                        <Box className='bookingDetails'>
                                            <Typography className='typo'>Discounts</Typography>
                                            <hr className='horizontalLine' />

                                            <Box className='addOns' style={{ boxShadow: "none", marginLeft: "0px" }}>
                                                <ThemeProvider theme={theme}>
                                                    <div style={{ display: "flex", width: '90%', marginLeft: '3%', marginTop: '3%', justifyContent: "space-between" }}>
                                                        <Select
                                                            style={{ width: "75%", textAlign: 'left', boxShadow: 'none' }}
                                                            id="discount"
                                                            value={this.state.discount?.name || ''}
                                                            label="Select Discount"
                                                            disabled={this.props.viewItem?.archived}
                                                            onChange={this.discountChange}
                                                        >
                                                            <MenuItem value="" disabled>
                                                                <em>Select Discount</em>
                                                            </MenuItem>
                                                            {this.state.discounts.map((discount, index) => (
                                                                <MenuItem key={index} value={discount.name}>
                                                                    {discount.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {!this.props.viewItem?.archived && <IconButton onClick={() => this.discountChange({ target: { value: "" } })}>
                                                            <CloseIcon />
                                                        </IconButton>}
                                                    </div>
                                                </ThemeProvider>
                                            </Box>
                                            <Box className='bookingRow' >
                                                <ThemeProvider theme={theme}>
                                                    <Box style={{ marginBottom: '7%' }}>
                                                        <Typography className='bookingLabel'>One-Time Discount</Typography>
                                                    </Box>
                                                    <Box style={{ justifyContent: 'end', marginBottom: '7%' }}>
                                                        <TextField style={{ width: '100%', marginRight: '-20%' }} onChange={this.addOneTimeDiscount}
                                                            id="oneTimeDiscount" type="number"
                                                            inputProps={{ step: "any", min: "0" }}
                                                            disabled={this.props.viewItem?.archived}
                                                            defaultValue={this.state.oneTimeDiscount || this.props.viewItem.onetime_discount}
                                                        />
                                                    </Box>
                                                </ThemeProvider>
                                            </Box>
                                        </Box>

                                        <Box className='bookingDetails'>
                                            <Typography className='bookingTypo'>Booking Details</Typography>
                                            <hr className='horizontalLine' />
                                            <Box className='bookingRow'>
                                                <Box>
                                                    <DateRangeIcon />
                                                    <Typography className='bookingLabel'>{this.props.viewItem.startdate}</Typography>
                                                </Box>
                                                <TrendingFlatIcon />
                                                <Box className='checkout'>
                                                    <DateRangeIcon />
                                                    <Typography className='bookingValue'>{this.props.viewItem.enddate}</Typography>
                                                </Box>
                                            </Box>
                                            <Box className='bookingRow'>
                                                <Box>
                                                    <GroupIcon />
                                                    <Typography className='bookingLabel'>Adults</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.adults}</Typography>
                                            </Box>
                                            <Box className='bookingRow'>
                                                <Box>
                                                    <FamilyRestroomIcon />
                                                    <Typography className='bookingLabel'>Children</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.kids}</Typography>
                                            </Box>
                                            <Box className='bookingRow'>
                                                <Box>
                                                    <PetsIcon />
                                                    <Typography className='bookingLabel'>Pets</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.pets}</Typography>
                                            </Box>
                                            {this.props.viewItem.rigname && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={rv} width="30px" />
                                                    <Typography className='bookingLabel'>Rig Type</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.rigname}</Typography>
                                            </Box>}
                                            {this.props.viewItem.slides>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={rv} width="30px" />
                                                    <Typography className='bookingLabel'>Slides</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.slides}</Typography>
                                            </Box>}
                                            {this.props.viewItem.rigLength>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={measuring} width="30px" />
                                                    <Typography className='bookingLabel'>Rig Length</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.rigLength}</Typography>
                                            </Box>}
                                            {this.props.viewItem.siteLength>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={measuring} width="30px" />
                                                    <Typography className='bookingLabel'>Site Length</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.siteLength}</Typography>
                                            </Box>}
                                            {this.props.viewItem.boatType && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={boat} width="30px" />
                                                    <Typography className='bookingLabel'>Boat</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.boatType}</Typography>
                                            </Box>}
                                            {this.props.viewItem.boatDraft>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={measuring} width="30px" />
                                                    <Typography className='bookingLabel'>Boat Draft</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.boatDraft}</Typography>
                                            </Box>}
                                            {this.props.viewItem.boatLength>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={measuring} width="30px" />
                                                    <Typography className='bookingLabel'>Boat Length</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.boatLength}</Typography>
                                            </Box>}
                                            {this.props.viewItem.boatBeam>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={measuring} width="30px" />
                                                    <Typography className='bookingLabel'>Boat Beam</Typography>
                                                </Box>
                                                <Typography className='bookingValue'>{this.props.viewItem.boatBeam}</Typography>
                                            </Box>}
                                            {this.props.viewItem.freshWater>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={freshWater} width="30px" />
                                                    <Typography className='bookingLabel'>Fresh Water</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            {this.props.viewItem.pumpOut>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={pumpOut} width="30px" />
                                                    <Typography className='bookingLabel'>Pump out</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            {this.props.viewItem.e15a>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={power} width="30px" />
                                                    <Typography className='bookingLabel'>Power 15amp</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            {this.props.viewItem.e30a>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={power} width="30px" />
                                                    <Typography className='bookingLabel'>Power 30 amp</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            {this.props.viewItem.e50a>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={power} width="30px" />
                                                    <Typography className='bookingLabel'>Power 50 amp</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            {this.props.viewItem.e100a>0 && <Box className='bookingRow'>
                                                <Box>
                                                    <img src={power} width="30px" />
                                                    <Typography className='bookingLabel'>Power 100 amp</Typography>
                                                </Box>
                                                {/* <Typography className='bookingValue'>{this.props.pets}</Typography> */}
                                            </Box>}
                                            <hr className='horizontalLine' />
                                            <Box className='bookingRow'>
                                                <Typography className='bookingLabel'>Site Name</Typography>
                                                <Typography className='bookingValue'>{this.props.viewItem?.sitename}</Typography>
                                            </Box>
                                            <Box className='bookingRow'>
                                                <Typography className='bookingLabel'>Site Type</Typography>
                                                <Typography className='bookingValue'>{this.props.viewItem?.sitetype}</Typography>
                                            </Box>
                                            {this.state.blended && <Box className='bookingRow'>
                                                <Typography className='bookingLabel'> </Typography>
                                                <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>Blended Rate</Typography>
                                            </Box>}
                                            {this.props.viewItem.seasonal === 1
                                                ?
                                                <>
                                                    <Box className='bookingRow'>
                                                        <Typography className='bookingLabel'>Seasonal</Typography>
                                                        <Typography className='bookingValue'>${!isNaN(parseFloat(this.state.seasonTotal).toFixed(2)) ? parseFloat(this.state.seasonTotal).toFixed(2) : this.props.viewItem.total}</Typography>
                                                    </Box>
                                                </>
                                                : <>
                                                    {this.state.months > 0
                                                        ? <Box className='bookingRow'>
                                                            <Typography className='bookingLabel'>Months Total ({this.state.months})</Typography>
                                                            <Typography className='bookingValue'>${!isNaN(parseFloat(this.state.monthsTotal).toFixed(2)) ? parseFloat(this.state.monthsTotal).toFixed(2):  this.state.monthsTotal}</Typography>
                                                        </Box>
                                                        : null
                                                    }
                                                    {this.state.weeks > 0
                                                        ? <Box className='bookingRow'>
                                                            <Typography className='bookingLabel'>Weeks Total ({this.state.weeks})</Typography>
                                                            <Typography className='bookingValue'>${!isNaN(parseFloat(this.state.weeksTotal).toFixed(2)) ? parseFloat(this.state.weeksTotal).toFixed(2) : this.state.weeksTotal}</Typography>
                                                        </Box>
                                                        : null
                                                    }
                                                    {this.state.days > 0
                                                        ? <Box className='bookingRow'>
                                                            <Typography className='bookingLabel'>Days Total ({this.state.days})</Typography>
                                                            <Typography className='bookingValue'>${!isNaN(parseFloat(this.state.daysTotal).toFixed(2)) ? parseFloat(this.state.daysTotal).toFixed(2) : this.state.daysTotal}</Typography>
                                                        </Box>
                                                        : null
                                                    }

                                                </>
                                            }
                                            {this.state.discountTotal != null
                                                ? <Box className='bookingRow'>
                                                    {this.state.discountByPercent
                                                        ?
                                                        <Typography className='bookingLabel'>Discount ({this.state.discountPercent}%)</Typography>
                                                        :
                                                        <Typography className='bookingLabel'>Discount </Typography>
                                                    }
                                                    <Typography className='bookingValue'>${parseFloat(this.state.discountTotal).toFixed(2)}</Typography>
                                                </Box>
                                                : null
                                            }
                                            {this.state.oneTimeDiscount > 0.00
                                                ? <Box className='bookingRow'>
                                                    <Typography className='bookingLabel'>One-Time Discount</Typography>
                                                    <Typography className='bookingValue'>${this.state.oneTimeDiscount}</Typography>
                                                </Box>
                                                : null
                                            }
                                            {Array.isArray(this.state.selectedExtras) && this.state.selectedExtras.length > 0
                                                ? <>
                                                    {this.state.selectedExtras.map((extraName, index) => (
                                                        <Box className='bookingRow' key={index}>
                                                            <Typography className='bookingLabel'>{extraName} ({this.state.selectedExtraCount[index]})</Typography>
                                                            <Typography className='bookingValue'>${parseFloat(this.state.selectedExtraAmount[index]).toFixed(2)}</Typography>
                                                        </Box>
                                                    ))}
                                                </>
                                                : null
                                            }
                                            <hr className='horizontalLine' />
                                            <Box className='bookingRow'>
                                                <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>{this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 'Gross Total' : 'Sub Total'}</Typography>
                                                <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${!isNaN(parseFloat(this.state.subTotal).toFixed(2)) ? parseFloat(this.state.subTotal).toFixed(2) : this.props.viewItem.total}</Typography>
                                            </Box>
                                            <hr className='horizontalLine' />
                                            {this.state.taxName.map((taxName, index) => (
                                                <Box className='bookingRow' key={index}>
                                                    <Typography className='bookingLabel'>{taxName} ({this.state.taxPercent[index]}%)</Typography>
                                                    <Typography className='bookingValue'>${parseFloat(this.state.tax[index]).toFixed(2)}</Typography>
                                                </Box>
                                            ))}
                                            {this.state.variableCharges.length > 0
                                                ?
                                                <>
                                                    <hr className='horizontalLine' />
                                                    {this.state.variableCharges.map((variableCharge, index) => (
                                                        <Box className='bookingRow'>
                                                            <Typography className='bookingLabel'>{variableCharge.detail}</Typography>
                                                            <Typography className='bookingValue'>${parseFloat(variableCharge.amount).toFixed(2)}</Typography>
                                                        </Box>
                                                    ))}
                                                </>
                                                : null
                                            }
                                            <hr className='horizontalLine' />

                                            <Box className='bookingRow'>
                                                <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>{this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' ? 'Net Total' : 'Total'}</Typography>
                                                <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${!isNaN(parseFloat(this.state.totalAmount).toFixed(2)) ? parseFloat(this.state.totalAmount).toFixed(2) : this.props.viewItem.total + this.props.viewItem.tax_amount}</Typography>
                                            </Box>

                                            {this.state.payments.length > 0
                                                ? <>
                                                    <hr className='horizontalLine' />
                                                    <Box className='bookingRow'>
                                                        <Typography className='bookingLabel'>Payments</Typography>
                                                    </Box>
                                                    {this.state.payments.map((payment, index) => (
                                                        <Box className='bookingRow' key={index}>
                                                            <Typography className='bookingLabel'>{payment.memo}</Typography>
                                                            <Typography className='bookingValue'>${parseFloat(payment.amount).toFixed(2)}</Typography>
                                                        </Box>
                                                    ))}
                                                </>
                                                : null
                                            }
                                            {this.state.totalPaidAmount > 0.0
                                                ?
                                                <>
                                                    <hr className='horizontalLine' />
                                                    <Box className='bookingRow' >
                                                        <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>Amount Due</Typography>
                                                        <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${!isNaN((this.state.totalAmount - this.state.totalPaidAmount).toFixed(2)) ? (this.state.totalAmount - this.state.totalPaidAmount).toFixed(2) : this.props.viewItem.total + this.props.viewItem.tax_amount - this.props.viewItem.amount_paid}</Typography>
                                                    </Box>
                                                </>
                                                : null
                                            }
                                            {this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o'
                                                ?
                                                <>
                                                    <hr className='horizontalLine' />
                                                    <Box className='bookingRow'>
                                                        <Typography className='bookingLabel'>{this.state.oldVariableCharge > 0.00 ? 'Additional Service Charge' : 'Service Charge'}</Typography>
                                                        <Typography className='bookingValue'>${!isNaN(parseFloat(this.state.convenienceCharge).toFixed(2)) ? parseFloat(this.state.convenienceCharge).toFixed(2) : ""}</Typography>
                                                    </Box>
                                                </>
                                                : null
                                            }
                                        </Box>

                                        {!this.props.viewItem?.archived && this.state.blended && <Box className='bookingDetails'>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography className='typo'>Blended Rates Info</Typography>
                                            </div>
                                            <hr className='horizontalLine' />
                                            <ThemeProvider theme={theme}>
                                            <div style={{overflowX: 'scroll'}}>
                                            <Box sx={{ width: '130%'}}>
                                                <Grid container spacing={3} style={{padding:'10px'}}>
                                                    <Grid item xs={3}>
                                                        <Typography className="bookingLabel" style={{fontWeight:'bold', fontSize: '15px'}}>Start</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography className="bookingLabel" style={{fontWeight:'bold', fontSize: '15px'}}>End</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography className="bookingLabel" style={{fontWeight:'bold', fontSize: '15px'}}>Count</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography className="bookingLabel" style={{fontWeight:'bold', fontSize: '15px'}}>Season</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography className="bookingLabel" style={{fontWeight:'bold', fontSize: '15px'}}>Amount</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {this.state.monthChunks?.length && <h4 style={{textAlign:'left', margin:'10px 15px'}}>Months</h4>}
                                            {this.state.monthChunks?.length
                                            && this.state.monthChunks.map(monthchunk => 
                                            <Box style={{ width:'130%' }}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{monthchunk.from}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{monthchunk.to}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{monthchunk.months}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{monthchunk.season}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{monthchunk.cost}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box> )
                                            }
                                            {this.state.weekChunks?.length && <h5 style={{textAlign:'left', margin:'10px 15px'}}>Weeks</h5>}
                                            {this.state.weekChunks?.length
                                            && this.state?.weekChunks.map(weekChunk => 
                                            <Box style={{ width:'130%' }}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{weekChunk.from}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{weekChunk.to}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{weekChunk.weeks}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{weekChunk.season}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{weekChunk.cost}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box> )
                                            }
                                            {this.state.dayChunks?.length && <h5 style={{textAlign:'left', margin:'10px 15px'}}>Days</h5>}
                                            {(this.state.dayChunks?.length)
                                            && this.state.dayChunks.map(dayChunk => 
                                            <Box style={{ width:'130%' }}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{dayChunk.from}</Typography>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Typography style={{ fontSize: '13px' }}>{dayChunk.to}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>1</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{dayChunk.season}</Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography style={{ fontSize: '13px' }}>{dayChunk.cost}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box> )
                                            }
                                            </div>
                                            </ThemeProvider>
                                        </Box>}

                                        <Box className='bookingDetails'>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Typography className='typo'>Internal Notes</Typography>
                                                {this.state.disabledInternalNotes
                                                    ? <Button style={{ margin: '4% 4% 0 0', height: '5%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                        onClick={() => { this.setState({ disabledInternalNotes: false }) }} disabled={this.props.viewItem.archived}> Edit Notes</Button>
                                                    :
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '30%', alignItems: 'center', margin: '1% 3% 0 0' }}>
                                                        <Button style={{ margin: '4% 4% 0 0', height: '70%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    disabledInternalNotes: true,
                                                                    internalNote: this.props.viewItem.special_request
                                                                })
                                                            }}> Cancel</Button>
                                                        <Button style={{ margin: '4% 4% 0 0', height: '70%', backgroundColor: '#2dcd7a', textTransform: 'capitalize' }}
                                                            onClick={() => { this.updateInternalNotes() }}> Save</Button>
                                                    </div>
                                                }
                                            </div>
                                            <hr className='horizontalLine' />
                                            <ThemeProvider theme={theme}>
                                                <textarea rows={15} id="internalNote" onChange={this.userDetailsChange} disabled={this.state.disabledInternalNotes} value={this.state.internalNote}
                                                    style={{ width: '85%', marginBottom: '2%', whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                                                    className={this.state.disabledInternalNotes ? 'custom-disabled-textArea' : ''}
                                                />
                                            </ThemeProvider>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </>
                    }

                </>
            )
        }
    };
};
export default withRouter(withStyles(useStyles)(View));